/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type ActiveBannerInput = {
  bannerId: Scalars['Float']['input'];
};

export type ActiveBannerOptionInput = {
  bannerOptionId: Scalars['Float']['input'];
};

export type ActiveBannerOptionOutput = {
  __typename?: 'ActiveBannerOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ActiveBannerOutput = {
  __typename?: 'ActiveBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isRep: Scalars['Boolean']['output'];
  mainAddress?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pass?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Port>;
  region?: Maybe<Scalars['String']['output']>;
  subAddress?: Maybe<Scalars['String']['output']>;
  user: User;
  username?: Maybe<Scalars['String']['output']>;
  zoneCode?: Maybe<Scalars['String']['output']>;
};

export type Banner = {
  __typename?: 'Banner';
  bannerMain?: Maybe<Array<BannerMain>>;
  bannerOptions?: Maybe<Array<BannerOption>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type BannerMain = {
  __typename?: 'BannerMain';
  alt?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Banner>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<BannerMainEvent>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  isEvent: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isOnePlusOne: Scalars['Boolean']['output'];
  isRes: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkServices?: Maybe<Array<LinkService>>;
  mainType?: Maybe<BannerMainType>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
};

export type BannerMainEvent = {
  __typename?: 'BannerMainEvent';
  bannerMain?: Maybe<BannerMain>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
};

export enum BannerMainType {
  Image = 'Image',
  Video = 'Video'
}

export type BannerOption = {
  __typename?: 'BannerOption';
  alt?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Banner>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isEvent: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isOnePlusOne: Scalars['Boolean']['output'];
  isRes: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
};

export type BasketItem = {
  __typename?: 'BasketItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good: Good;
  goodOption?: Maybe<GoodOption>;
  id: Scalars['Float']['output'];
  isBasket?: Maybe<Scalars['Boolean']['output']>;
  quantity: Scalars['Float']['output'];
  receipt?: Maybe<Receipt>;
  user: User;
};

export type ChangeActiveInput = {
  corporationId: Scalars['Float']['input'];
};

export type ChangeActiveOutput = {
  __typename?: 'ChangeActiveOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeOrderOutput = {
  __typename?: 'ChangeOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeOutput = {
  __typename?: 'ChangeOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeServiceActiveInput = {
  serviceId: Scalars['Float']['input'];
};

export type ChangeServiceActiveOutput = {
  __typename?: 'ChangeServiceActiveOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChkAddressAreaInput = {
  region?: InputMaybe<Scalars['String']['input']>;
};

export type ChkAddressAreaOutput = {
  __typename?: 'ChkAddressAreaOutput';
  deliveryArea?: Maybe<Scalars['Boolean']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  author: User;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  inquiry: Inquiry;
  note: Scalars['String']['output'];
};

export type ConfirmOrderKioskInput = {
  orderId: Scalars['Float']['input'];
  simplePassword: Scalars['String']['input'];
};

export type ConfirmOrderKioskOutput = {
  __typename?: 'ConfirmOrderKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CoreOutput = {
  __typename?: 'CoreOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Corporation = {
  __typename?: 'Corporation';
  address?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  author?: Maybe<User>;
  businessAddress?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessNumber?: Maybe<Scalars['String']['output']>;
  ceoName?: Maybe<Scalars['String']['output']>;
  coupons?: Maybe<Array<Coupon>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryLimitQuantity?: Maybe<Scalars['Float']['output']>;
  goodOptions?: Maybe<Array<GoodOption>>;
  goods?: Maybe<Array<Good>>;
  holiday?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isManualActive: Scalars['Boolean']['output'];
  linkService?: Maybe<LinkService>;
  mainCategories?: Maybe<Array<MainCategory>>;
  managerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operationFrom?: Maybe<Scalars['String']['output']>;
  operationTo?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  regionKeyWord?: Maybe<Array<Scalars['String']['output']>>;
  subCategories?: Maybe<Array<SubCategory>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  code?: Maybe<Scalars['String']['output']>;
  corporation?: Maybe<Corporation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  linkService?: Maybe<LinkService>;
  name: Scalars['String']['output'];
  scope: CouponScope;
  status: CouponStatus;
  usageLimit: Scalars['Float']['output'];
  userCoupons?: Maybe<Array<UserCoupon>>;
  userUsageLimit: Scalars['Float']['output'];
  validFrom: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export enum CouponScope {
  Corporation = 'CORPORATION',
  Global = 'GLOBAL',
  LinkService = 'LINK_SERVICE'
}

export enum CouponStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export type CouponWithAvailability = {
  __typename?: 'CouponWithAvailability';
  coupon: Coupon;
  isAvailable: Scalars['Boolean']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
  userCouponId?: Maybe<Scalars['Float']['output']>;
  userCouponStatus?: Maybe<UserCouponStatus>;
};

export type CrAddressInput = {
  isRep: Scalars['Boolean']['input'];
  mainAddress?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subAddress?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type CrAddressOutput = {
  __typename?: 'CrAddressOutput';
  addressId?: Maybe<Scalars['Float']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBannerInput = {
  title: Scalars['String']['input'];
};

export type CrBannerMainInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  linkServiceId?: InputMaybe<Scalars['Float']['input']>;
  mainType: BannerMainType;
};

export type CrBannerMainOutput = {
  __typename?: 'CrBannerMainOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBannerOptionOutput = {
  __typename?: 'CrBannerOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBannerOutput = {
  __typename?: 'CrBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBasketItemInput = {
  basketInfos?: InputMaybe<Array<DetailCrBasketInput>>;
};

export type CrBasketItemOutput = {
  __typename?: 'CrBasketItemOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrCommentInput = {
  inquiryId: Scalars['Float']['input'];
  note: Scalars['String']['input'];
};

export type CrCommentOutput = {
  __typename?: 'CrCommentOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrCorporationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deliveryLimitQuantity?: InputMaybe<Scalars['Float']['input']>;
  holiday?: InputMaybe<Scalars['String']['input']>;
  mainCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
};

export type CrCorporationOutput = {
  __typename?: 'CrCorporationOutput';
  createdId: Scalars['Float']['output'];
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  linkServiceId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  scope: CouponScope;
  status: CouponStatus;
  usageLimit?: InputMaybe<Scalars['Float']['input']>;
  userUsageLimit?: InputMaybe<Scalars['Float']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type CrCouponOutput = {
  __typename?: 'CrCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrDefaultPocketInput = {
  direction: Scalars['Float']['input'];
  portId: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CrDefaultPocketOutput = {
  __typename?: 'CrDefaultPocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrDroneInput = {
  model: DroneModel;
  name: Scalars['String']['input'];
  serial?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DroneStatus>;
};

export type CrDroneOutput = {
  __typename?: 'CrDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrFlightInput = {
  droneId: Scalars['Float']['input'];
  landAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAt?: InputMaybe<Scalars['DateTime']['input']>;
  packId?: InputMaybe<Scalars['Float']['input']>;
  pilotFromId?: InputMaybe<Scalars['Float']['input']>;
  pilotToId?: InputMaybe<Scalars['Float']['input']>;
  portFromId: Scalars['Float']['input'];
  portToId: Scalars['Float']['input'];
  projectId: Scalars['Float']['input'];
  status?: InputMaybe<FlightStatus>;
  takeOffAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CrFlightOutput = {
  __typename?: 'CrFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodBulkElement = {
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  optionName: Scalars['String']['input'];
  plu?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodBulkInput = {
  goods: Array<CrGoodBulkElement>;
};

export type CrGoodBulkOutput = {
  __typename?: 'CrGoodBulkOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodDetailInput = {
  detailType: GoodDetailType;
  goodId: Scalars['Float']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodDetailOutput = {
  __typename?: 'CrGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  expirydate?: InputMaybe<Scalars['DateTime']['input']>;
  limitNumOrders?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status: Scalars['String']['input'];
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Tags>>;
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodOptionInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodOptionOutput = {
  __typename?: 'CrGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodOutput = {
  __typename?: 'CrGoodOutput';
  createdId: Scalars['Float']['output'];
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodPosterInput = {
  goodId: Scalars['Float']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodPosterOutput = {
  __typename?: 'CrGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodReviewInput = {
  goodReviewPosterIds: Array<Scalars['Float']['input']>;
  note: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  rating: Scalars['Float']['input'];
};

export type CrGoodReviewPosterInput = {
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodReviewPosterOutput = {
  __typename?: 'CrGoodReviewPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReviewPoster?: Maybe<GoodReviewPoster>;
  ok: Scalars['Boolean']['output'];
};

export type CrInquiryInput = {
  inquiryPosters?: InputMaybe<Array<Scalars['Float']['input']>>;
  note: Scalars['String']['input'];
  receiptId?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<InquiryType>;
};

export type CrInquiryOutput = {
  __typename?: 'CrInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrInquiryPosterInput = {
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrInquiryPosterOutput = {
  __typename?: 'CrInquiryPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiryPoster?: Maybe<InquiryPoster>;
  ok: Scalars['Boolean']['output'];
};

export type CrLinkServiceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
};

export type CrLinkServiceOutput = {
  __typename?: 'CrLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrMainCategoryInput = {
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CrMainCategoryOutput = {
  __typename?: 'CrMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrOrderReceiptOutput = {
  __typename?: 'CrOrderReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrPackInput = {
  orderIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CrPackOutput = {
  __typename?: 'CrPackOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pack?: Maybe<Pack>;
};

export type CrPortInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PortStatus>;
};

export type CrPortOutput = {
  __typename?: 'CrPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrProjectInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CrProjectOutput = {
  __typename?: 'CrProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrReceiptInput = {
  basketItemIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  buyInfos?: InputMaybe<Array<DetailCrReceiptInput>>;
};

export type CrReceiptOutput = {
  __typename?: 'CrReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type CrSnsUserInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sns?: InputMaybe<Sns>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CrSnsUserOutput = {
  __typename?: 'CrSnsUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CrUserCouponInput = {
  couponId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};

export type CrUserCouponOutput = {
  __typename?: 'CrUserCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrUserInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workerType?: InputMaybe<WorkerType>;
};

export type CrUserOutput = {
  __typename?: 'CrUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrgoodReviewOutput = {
  __typename?: 'CrgoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelAddressInput = {
  id: Scalars['Float']['input'];
};

export type DelAddressOutput = {
  __typename?: 'DelAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelBannerInput = {
  bannerId: Scalars['Float']['input'];
};

export type DelBannerMainInput = {
  bannerMainId: Scalars['Float']['input'];
};

export type DelBannerMainOutput = {
  __typename?: 'DelBannerMainOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelBannerOutput = {
  __typename?: 'DelBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelBasketItemInput = {
  basketItemIds: Array<Scalars['Float']['input']>;
};

export type DelBasketItemOutput = {
  __typename?: 'DelBasketItemOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelCommentInput = {
  commentId: Scalars['Float']['input'];
};

export type DelCommentOutput = {
  __typename?: 'DelCommentOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelCorporationInput = {
  corporationId: Scalars['Float']['input'];
};

export type DelCorporationOutput = {
  __typename?: 'DelCorporationOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelCouponInput = {
  couponId?: InputMaybe<Scalars['Float']['input']>;
};

export type DelCouponOutput = {
  __typename?: 'DelCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelDroneInput = {
  droneId: Scalars['Float']['input'];
};

export type DelDroneOutput = {
  __typename?: 'DelDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelFlightInput = {
  flightId: Scalars['Float']['input'];
};

export type DelFlightOutput = {
  __typename?: 'DelFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodDetailInput = {
  goodDetailId: Scalars['Float']['input'];
};

export type DelGoodDetailOutput = {
  __typename?: 'DelGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodInput = {
  goodId: Scalars['Float']['input'];
};

export type DelGoodOptionInput = {
  goodOptionId: Scalars['Float']['input'];
};

export type DelGoodOptionOutput = {
  __typename?: 'DelGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodOutput = {
  __typename?: 'DelGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodPosterInput = {
  goodPosterId: Scalars['Float']['input'];
};

export type DelGoodPosterOutput = {
  __typename?: 'DelGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodReviewInput = {
  reviewId: Scalars['Float']['input'];
};

export type DelGoodReviewOutput = {
  __typename?: 'DelGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodReviewPosterInput = {
  reviewPosterId: Scalars['Float']['input'];
};

export type DelGoodReviewPosterOutput = {
  __typename?: 'DelGoodReviewPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelInquiryInput = {
  inquiryId: Scalars['Float']['input'];
};

export type DelInquiryOutput = {
  __typename?: 'DelInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelInquiryPosterInput = {
  inquiryPosterId: Scalars['Float']['input'];
};

export type DelInquiryPosterOutput = {
  __typename?: 'DelInquiryPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelLinkServiceInput = {
  linkServiceId: Scalars['Float']['input'];
};

export type DelLinkServiceOutput = {
  __typename?: 'DelLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelMainCategoryInput = {
  id: Scalars['Float']['input'];
};

export type DelMainCategoryOutput = {
  __typename?: 'DelMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type DelOrderOutput = {
  __typename?: 'DelOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelPackInput = {
  packId?: InputMaybe<Scalars['Float']['input']>;
};

export type DelPackOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type DelPackOrderOutput = {
  __typename?: 'DelPackOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelPackOutput = {
  __typename?: 'DelPackOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelPortInput = {
  portId: Scalars['Float']['input'];
};

export type DelPortOutput = {
  __typename?: 'DelPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelProjectInput = {
  projectId?: InputMaybe<Scalars['Float']['input']>;
};

export type DelProjectOutput = {
  __typename?: 'DelProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelUserInput = {
  id: Scalars['Float']['input'];
};

export type DelUserOutput = {
  __typename?: 'DelUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DetailCrBasketInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
  goodOptionId?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type DetailCrReceiptInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
  goodOptionId?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type DetailedGoodOptionInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  dateActive?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Float']['input'];
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Drone = {
  __typename?: 'Drone';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['Float']['output'];
  model: DroneModel;
  name: Scalars['String']['output'];
  serial?: Maybe<Scalars['String']['output']>;
  status: DroneStatus;
};

export enum DroneModel {
  Af200 = 'AF200',
  Ds30 = 'DS30',
  Gd23Ot = 'GD23OT',
  P01 = 'P01',
  P05 = 'P05',
  Pandion = 'PANDION',
  Phv20 = 'PHV20'
}

export enum DroneStatus {
  Damage = 'Damage',
  Operating = 'Operating',
  Pending = 'Pending',
  Repair = 'Repair',
  Testing = 'Testing'
}

export type EditBannerInput = {
  bannerId: Scalars['Float']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditBannerMainIndexInput = {
  bannerMainId: Scalars['Float']['input'];
  index: Scalars['Float']['input'];
};

export type EditBannerMainIndexOutput = {
  __typename?: 'EditBannerMainIndexOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBannerMainInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  bannerMainId: Scalars['Float']['input'];
  eventActive?: InputMaybe<Scalars['Boolean']['input']>;
  eventLink?: InputMaybe<Scalars['String']['input']>;
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  eventUuid?: InputMaybe<Scalars['String']['input']>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isOnePlusOne?: InputMaybe<Scalars['Boolean']['input']>;
  isRes?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewUuid?: InputMaybe<Scalars['String']['input']>;
};

export type EditBannerMainOutput = {
  __typename?: 'EditBannerMainOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBannerOptionInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  bannerId: Scalars['Float']['input'];
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isOnePlusOne?: InputMaybe<Scalars['Boolean']['input']>;
  isRes?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewUuid?: InputMaybe<Scalars['String']['input']>;
};

export type EditBannerOptionOutput = {
  __typename?: 'EditBannerOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBannerOutput = {
  __typename?: 'EditBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBusinessInfoInput = {
  businessAddress: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  businessNumber: Scalars['String']['input'];
  ceoName: Scalars['String']['input'];
  corporationId: Scalars['Float']['input'];
};

export type EditBusinessInfoOutput = {
  __typename?: 'EditBusinessInfoOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditCommentInput = {
  commentId: Scalars['Float']['input'];
  note: Scalars['String']['input'];
};

export type EditCommentOutput = {
  __typename?: 'EditCommentOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditCorporationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  corporationId: Scalars['Float']['input'];
  deliveryLimitQuantity?: InputMaybe<Scalars['Float']['input']>;
  holiday?: InputMaybe<Scalars['String']['input']>;
  mainCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
};

export type EditCorporationOutput = {
  __typename?: 'EditCorporationOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  couponId?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  linkServiceId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  scope: CouponScope;
  status?: InputMaybe<CouponStatus>;
  usageLimit: Scalars['Float']['input'];
  userUsageLimit?: InputMaybe<Scalars['Float']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type EditCouponOutput = {
  __typename?: 'EditCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditDroneInput = {
  droneId: Scalars['Float']['input'];
  model: DroneModel;
  name: Scalars['String']['input'];
  serial?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DroneStatus>;
};

export type EditDroneOutput = {
  __typename?: 'EditDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditExchangeStatusInput = {
  exchangeStatus: ExchangeStatus;
  orderId: Scalars['Float']['input'];
};

export type EditExchangeStatusOutput = {
  __typename?: 'EditExchangeStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditFlightInput = {
  droneId: Scalars['Float']['input'];
  flightId: Scalars['Float']['input'];
  landAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAt?: InputMaybe<Scalars['DateTime']['input']>;
  packId?: InputMaybe<Scalars['Float']['input']>;
  pilotFromId?: InputMaybe<Scalars['Float']['input']>;
  pilotToId?: InputMaybe<Scalars['Float']['input']>;
  portFromId: Scalars['Float']['input'];
  portToId: Scalars['Float']['input'];
  projectId: Scalars['Float']['input'];
  status?: InputMaybe<FlightStatus>;
  takeOffAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EditFlightOutput = {
  __typename?: 'EditFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditFlightStatusInput = {
  flightId: Scalars['Float']['input'];
  status?: InputMaybe<FlightStatus>;
};

export type EditFlightStatusOutput = {
  __typename?: 'EditFlightStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodAttrInfoInput = {
  goodAttrInfo?: InputMaybe<Scalars['String']['input']>;
  goodId: Scalars['Float']['input'];
};

export type EditGoodAttrInfoOutput = {
  __typename?: 'EditGoodAttrInfoOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodAttrInput = {
  attributeSet?: InputMaybe<Scalars['String']['input']>;
  goodId: Scalars['Float']['input'];
};

export type EditGoodAttrOutput = {
  __typename?: 'EditGoodAttrOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodDetailIndexInput = {
  goodDetailId: Scalars['Float']['input'];
  index: Scalars['Float']['input'];
};

export type EditGoodDetailIndexOutput = {
  __typename?: 'EditGoodDetailIndexOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodDetailInput = {
  goodDetailId: Scalars['Float']['input'];
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EditGoodDetailOutput = {
  __typename?: 'EditGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  expirydate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  limitNumOrders?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<GoodStatus>;
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Tags>>;
  title?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type EditGoodOptionInput = {
  detailedGoodOptions?: InputMaybe<Array<DetailedGoodOptionInput>>;
};

export type EditGoodOptionOutput = {
  __typename?: 'EditGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodOrderInput = {
  goodId: Scalars['Float']['input'];
  goodOrder: GoodOrder;
};

export type EditGoodOrderOutput = {
  __typename?: 'EditGoodOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodOutput = {
  __typename?: 'EditGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodPosterInput = {
  goodPosterId: Scalars['Float']['input'];
  imageUuid: Scalars['String']['input'];
  index: Scalars['Float']['input'];
  isRep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditGoodPosterOutput = {
  __typename?: 'EditGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodReviewInput = {
  goodReviewPosterIds: Array<Scalars['Float']['input']>;
  note: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  reviewId: Scalars['Float']['input'];
};

export type EditGoodStatusInput = {
  goodId: Scalars['Float']['input'];
  status: GoodStatus;
};

export type EditGoodStatusOutput = {
  __typename?: 'EditGoodStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodsStatusInput = {
  goodIds: Array<Scalars['Float']['input']>;
  status: GoodStatus;
};

export type EditGoodsStatusOutput = {
  __typename?: 'EditGoodsStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditInquiryInput = {
  inquiryId: Scalars['Float']['input'];
  inquiryPosters?: InputMaybe<Array<Scalars['Float']['input']>>;
  note: Scalars['String']['input'];
  receiptId?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<InquiryType>;
};

export type EditInquiryOutput = {
  __typename?: 'EditInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditInquiryStatusInput = {
  inquiryId: Scalars['Float']['input'];
  status?: InputMaybe<InquiryStatus>;
};

export type EditInquiryStatusOutput = {
  __typename?: 'EditInquiryStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditLinkServiceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkServiceId: Scalars['Float']['input'];
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
};

export type EditLinkServiceOutput = {
  __typename?: 'EditLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditMainCategoryInput = {
  id: Scalars['Float']['input'];
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditMainCategoryOutput = {
  __typename?: 'EditMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderEndDateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['Float']['input'];
};

export type EditOrderEndDateOutput = {
  __typename?: 'EditOrderEndDateOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusDeliveredInput = {
  orderId: Scalars['Float']['input'];
};

export type EditOrderStatusDeliveredOutput = {
  __typename?: 'EditOrderStatusDeliveredOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusInput = {
  orderId: Scalars['Float']['input'];
  status: OrderStatus;
};

export type EditOrderStatusOutput = {
  __typename?: 'EditOrderStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusStoredInput = {
  orderId: Scalars['Float']['input'];
};

export type EditOrderStatusStoredOutput = {
  __typename?: 'EditOrderStatusStoredOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusWithQuantityInput = {
  orderId: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status: OrderStatus;
};

export type EditOrderStatusWithQuantityOutput = {
  __typename?: 'EditOrderStatusWithQuantityOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrdersStatusInput = {
  orderIds: Array<Scalars['Float']['input']>;
  status: OrderStatus;
};

export type EditOrdersStatusOutput = {
  __typename?: 'EditOrdersStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditPortInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deliveryRegion?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pickUp?: InputMaybe<Scalars['Boolean']['input']>;
  portId: Scalars['Float']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
  regionKeyWord?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PortStatus>;
  usageTime?: InputMaybe<Scalars['String']['input']>;
};

export type EditPortOutput = {
  __typename?: 'EditPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditProjectInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ProjectStatus>;
};

export type EditProjectOutput = {
  __typename?: 'EditProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditReceiptAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  receiptId: Scalars['Float']['input'];
};

export type EditReceiptAddressOutput = {
  __typename?: 'EditReceiptAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditgoodReviewOutput = {
  __typename?: 'EditgoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EndLoadPocketInput = {
  pocketId: Scalars['Float']['input'];
};

export type EndLoadPocketOutput = {
  __typename?: 'EndLoadPocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EndSavePocketInput = {
  pocketId: Scalars['Float']['input'];
};

export type EndSavePocketOutput = {
  __typename?: 'EndSavePocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum ExchangeStatus {
  Complete = 'Complete',
  Pending = 'Pending',
  PickUp = 'PickUp',
  ReDelivery = 'ReDelivery',
  Refunded = 'Refunded'
}

export type Flight = {
  __typename?: 'Flight';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  drone?: Maybe<Drone>;
  flightTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  landAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderAt?: Maybe<Scalars['DateTime']['output']>;
  pack?: Maybe<Pack>;
  pilotFrom?: Maybe<User>;
  pilotTo?: Maybe<User>;
  portFrom?: Maybe<Port>;
  portTo?: Maybe<Port>;
  project?: Maybe<Project>;
  status?: Maybe<FlightStatus>;
  takeOffAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum FlightStatus {
  Cancel = 'Cancel',
  Land = 'Land',
  Ready = 'Ready',
  Stop = 'Stop',
  TakeOff = 'TakeOff'
}

export type GetAddressInput = {
  id: Scalars['Float']['input'];
};

export type GetAddressOutput = {
  __typename?: 'GetAddressOutput';
  address?: Maybe<Address>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerInput = {
  bannerId: Scalars['Float']['input'];
};

export type GetBannerMainActiveInput = {
  serviceName: Scalars['String']['input'];
};

export type GetBannerMainActiveOutput = {
  __typename?: 'GetBannerMainActiveOutput';
  bannerMain?: Maybe<Array<BannerMain>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerMainEventInput = {
  eventId: Scalars['Float']['input'];
};

export type GetBannerMainInput = {
  bannerMainId: Scalars['Float']['input'];
};

export type GetBannerOptionActiveOutput = {
  __typename?: 'GetBannerOptionActiveOutput';
  bannerOption?: Maybe<Array<BannerOption>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerOutput = {
  __typename?: 'GetBannerOutput';
  banner?: Maybe<Banner>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetCorporationCategoryInput = {
  corporationId: Scalars['Float']['input'];
};

export type GetCorporationCategoryOutput = {
  __typename?: 'GetCorporationCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  subCategories?: Maybe<Array<SubCategory>>;
};

export type GetCorporationInput = {
  corporationId: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCorporationOutput = {
  __typename?: 'GetCorporationOutput';
  corporation?: Maybe<Corporation>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetCouponInput = {
  couponId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCouponOutput = {
  __typename?: 'GetCouponOutput';
  coupon?: Maybe<Coupon>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetDroneInput = {
  droneId: Scalars['Float']['input'];
};

export type GetDroneOutput = {
  __typename?: 'GetDroneOutput';
  drone?: Maybe<Drone>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetFlightInput = {
  flightId: Scalars['Float']['input'];
};

export type GetFlightOutput = {
  __typename?: 'GetFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  flight?: Maybe<Flight>;
  ok: Scalars['Boolean']['output'];
};

export type GetGoodInput = {
  goodId: Scalars['Float']['input'];
};

export type GetGoodOutput = {
  __typename?: 'GetGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  good?: Maybe<Good>;
  ok: Scalars['Boolean']['output'];
};

export type GetGoodReviewInput = {
  reviewId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetGoodReviewOutput = {
  __typename?: 'GetGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReview?: Maybe<GoodReview>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type GetInquiryInput = {
  inquiryId: Scalars['Float']['input'];
};

export type GetInquiryOutput = {
  __typename?: 'GetInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiry?: Maybe<Inquiry>;
  ok: Scalars['Boolean']['output'];
};

export type GetJoinUserCertInput = {
  id: Scalars['Float']['input'];
  imp_uid: Scalars['String']['input'];
};

export type GetJoinUserCertOutput = {
  __typename?: 'GetJoinUserCertOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type GetKakaoEmailInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type GetKakaoEmailOutput = {
  __typename?: 'GetKakaoEmailOutput';
  email?: Maybe<Scalars['String']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetLinkServiceInput = {
  linkServiceId: Scalars['Float']['input'];
};

export type GetLinkServiceNearInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type GetLinkServiceNearOutput = {
  __typename?: 'GetLinkServiceNearOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<LinkService>;
  ok: Scalars['Boolean']['output'];
};

export type GetLinkServiceOutput = {
  __typename?: 'GetLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkService?: Maybe<LinkService>;
  ok: Scalars['Boolean']['output'];
};

export type GetMainCategoryInput = {
  id: Scalars['Float']['input'];
};

export type GetMainCategoryOutput = {
  __typename?: 'GetMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  mainCategory?: Maybe<MainCategory>;
  ok: Scalars['Boolean']['output'];
};

export type GetOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type GetOrderOutput = {
  __typename?: 'GetOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  order: Order;
};

export type GetPaymentDataInput = {
  imp_uid?: InputMaybe<Scalars['String']['input']>;
  receiptUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetPaymentDataOutput = {
  __typename?: 'GetPaymentDataOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type GetPgOptionInput = {
  receiptId: Scalars['Float']['input'];
};

export type GetPgOptionOutput = {
  __typename?: 'GetPgOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pgOption?: Maybe<PgOption>;
};

export type GetPortInput = {
  portId: Scalars['Float']['input'];
};

export type GetPortOutput = {
  __typename?: 'GetPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  port?: Maybe<Port>;
};

export type GetProjectInput = {
  projectId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetProjectOutput = {
  __typename?: 'GetProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
};

export type GetReceiptInput = {
  receiptUuid: Scalars['String']['input'];
};

export type GetReceiptOutput = {
  __typename?: 'GetReceiptOutput';
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type GetUpUserCertInput = {
  imp_uid: Scalars['String']['input'];
};

export type GetUpUserCertOutput = {
  __typename?: 'GetUpUserCertOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type GetUserEmailInput = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GetUserEmailOutput = {
  __typename?: 'GetUserEmailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type Good = {
  __typename?: 'Good';
  attributeSet?: Maybe<Scalars['String']['output']>;
  author?: Maybe<User>;
  basketItems?: Maybe<Array<BasketItem>>;
  corporation?: Maybe<Corporation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  expirydate?: Maybe<Scalars['DateTime']['output']>;
  goodAttrInfo?: Maybe<Scalars['String']['output']>;
  goodDetails?: Maybe<Array<GoodDetail>>;
  goodOptions?: Maybe<Array<GoodOption>>;
  goodOrder?: Maybe<GoodOrder>;
  goodPosters?: Maybe<Array<GoodPoster>>;
  goodRelations?: Maybe<Array<GoodRelation>>;
  goodReviews?: Maybe<Array<GoodReview>>;
  id: Scalars['Float']['output'];
  likeCount: Scalars['Float']['output'];
  limitNumOrders: Scalars['Float']['output'];
  orders?: Maybe<Array<Order>>;
  plu?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  related?: Maybe<GoodRelation>;
  status: GoodStatus;
  subCategory?: Maybe<SubCategory>;
  suggestion: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tags>>;
  title: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  views: Scalars['Float']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type GoodDetail = {
  __typename?: 'GoodDetail';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detailType?: Maybe<GoodDetailType>;
  file?: Maybe<Scalars['String']['output']>;
  good?: Maybe<Good>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum GoodDetailType {
  ContentArea = 'ContentArea',
  Image = 'Image',
  Paragraph = 'Paragraph',
  TextArea = 'TextArea',
  Video = 'Video'
}

export type GoodOption = {
  __typename?: 'GoodOption';
  attributeSet?: Maybe<Scalars['String']['output']>;
  basketItems?: Maybe<Array<BasketItem>>;
  corporation?: Maybe<Corporation>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateActive: Scalars['Boolean']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  expirydate?: Maybe<Scalars['DateTime']['output']>;
  good?: Maybe<Good>;
  goodAttrInfo?: Maybe<Scalars['String']['output']>;
  goodOptionUuid?: Maybe<Scalars['String']['output']>;
  goodOrder?: Maybe<GoodOrder>;
  id: Scalars['Float']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isEvent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Order>>;
  price?: Maybe<Scalars['Float']['output']>;
  relatedThisGoodOption?: Maybe<Array<GoodRelation>>;
  stock?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export enum GoodOrder {
  None = 'None',
  Order = 'Order'
}

export type GoodPoster = {
  __typename?: 'GoodPoster';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good?: Maybe<Good>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  isRep: Scalars['Boolean']['output'];
  upload?: Maybe<Upload>;
};

export type GoodRelation = {
  __typename?: 'GoodRelation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good?: Maybe<Good>;
  goodOption?: Maybe<GoodOption>;
  id: Scalars['Float']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  relatedGoods?: Maybe<Array<Good>>;
};

export type GoodReview = {
  __typename?: 'GoodReview';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good: Good;
  goodReviewPosters?: Maybe<Array<GoodReviewPoster>>;
  id: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  order?: Maybe<Order>;
  rating: Scalars['Float']['output'];
};

export type GoodReviewPoster = {
  __typename?: 'GoodReviewPoster';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  review?: Maybe<GoodReview>;
  upload?: Maybe<Upload>;
};

export enum GoodStatus {
  GoodSales = 'GoodSales',
  Make = 'Make',
  Ready = 'Ready',
  Sales = 'Sales',
  SoldOut = 'SoldOut',
  Etc = 'etc',
  GoodReady = 'goodReady',
  NotSale = 'notSale'
}

export enum HowToReceive {
  Delivery = 'Delivery',
  PickUp = 'PickUp'
}

export type Inquiry = {
  __typename?: 'Inquiry';
  author: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inquiryPosters?: Maybe<Array<InquiryPoster>>;
  manager?: Maybe<User>;
  note: Scalars['String']['output'];
  receipt?: Maybe<Receipt>;
  status: InquiryStatus;
  title: Scalars['String']['output'];
  type: InquiryType;
};

export type InquiryPoster = {
  __typename?: 'InquiryPoster';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  inquiry?: Maybe<Inquiry>;
  upload?: Maybe<Upload>;
};

export enum InquiryStatus {
  Complete = 'Complete',
  Fail = 'Fail',
  New = 'New',
  Pending = 'Pending',
  PendingRefund = 'PendingRefund',
  Refund = 'Refund',
  Reply = 'Reply'
}

export enum InquiryType {
  Goods = 'Goods',
  Question = 'Question',
  Refund = 'Refund',
  System = 'System'
}

export type LinkService = {
  __typename?: 'LinkService';
  address?: Maybe<Scalars['String']['output']>;
  bannerMains?: Maybe<Array<BannerMain>>;
  corporations?: Maybe<Corporation>;
  coupons?: Maybe<Array<Coupon>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isManualActive: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  minAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  operationFrom?: Maybe<Scalars['String']['output']>;
  operationTo?: Maybe<Scalars['String']['output']>;
  ports?: Maybe<Array<Port>>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ListAddressOutput = {
  __typename?: 'ListAddressOutput';
  address?: Maybe<Array<Address>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListBannerInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListBannerMainInput = {
  linkServiceId: Scalars['Float']['input'];
};

export type ListBannerMainOutput = {
  __typename?: 'ListBannerMainOutput';
  bannerMain?: Maybe<Array<BannerMain>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListBannerOptionOutput = {
  __typename?: 'ListBannerOptionOutput';
  bannerOptions?: Maybe<Array<BannerOption>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListBannerOutput = {
  __typename?: 'ListBannerOutput';
  banners?: Maybe<Array<Banner>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListBasketItemOutput = {
  __typename?: 'ListBasketItemOutput';
  basketItems?: Maybe<Array<BasketItem>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListBasketItemServiceInput = {
  serviceId: Scalars['Float']['input'];
};

export type ListBasketItemServiceOutput = {
  __typename?: 'ListBasketItemServiceOutput';
  basketItems?: Maybe<Array<BasketItem>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCommentInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  inquiryId: Scalars['Float']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListCommentOutput = {
  __typename?: 'ListCommentOutput';
  comments?: Maybe<Array<Comment>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListCorporationByLocationInput = {
  serviceId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCorporationByLocationOutput = {
  __typename?: 'ListCorporationByLocationOutput';
  corporations?: Maybe<Array<Corporation>>;
  err?: Maybe<Scalars['String']['output']>;
  mainCategories?: Maybe<Array<MainCategory>>;
  ok: Scalars['Boolean']['output'];
};

export type ListCorporationInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListCorporationOutput = {
  __typename?: 'ListCorporationOutput';
  corporations?: Maybe<Array<Corporation>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListCorporationSelectOutput = {
  __typename?: 'ListCorporationSelectOutput';
  corporations?: Maybe<Array<Corporation>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCouponCorporationInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCouponCorporationOutput = {
  __typename?: 'ListCouponCorporationOutput';
  coupons?: Maybe<Array<Coupon>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCouponInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListCouponLocationInput = {
  serviceId: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCouponLocationOutput = {
  __typename?: 'ListCouponLocationOutput';
  coupons?: Maybe<Array<CouponWithAvailability>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCouponOutput = {
  __typename?: 'ListCouponOutput';
  coupons?: Maybe<Array<Coupon>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListDriverSelectOutput = {
  __typename?: 'ListDriverSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type ListDroneInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListDroneOutput = {
  __typename?: 'ListDroneOutput';
  drones?: Maybe<Array<Drone>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListDroneSelectOutput = {
  __typename?: 'ListDroneSelectOutput';
  drones?: Maybe<Array<Drone>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListFlightInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListFlightOutput = {
  __typename?: 'ListFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  flights?: Maybe<Array<Flight>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListGoodAllOutput = {
  __typename?: 'ListGoodAllOutput';
  err?: Maybe<Scalars['String']['output']>;
  goods?: Maybe<Array<Good>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodDetailInput = {
  goodId: Scalars['Float']['input'];
};

export type ListGoodDetailOutput = {
  __typename?: 'ListGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodDetails?: Maybe<Array<GoodDetail>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<GoodStatus>;
  tag?: InputMaybe<Tags>;
};

export type ListGoodOptionInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListGoodOptionOutput = {
  __typename?: 'ListGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodOptions?: Maybe<Array<GoodOption>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodOutput = {
  __typename?: 'ListGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  goods?: Maybe<Array<Good>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListGoodPosterInput = {
  goodId: Scalars['Float']['input'];
};

export type ListGoodPosterOutput = {
  __typename?: 'ListGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodPosters?: Maybe<Array<GoodPoster>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodRelationInput = {
  goodId: Scalars['Float']['input'];
};

export type ListGoodRelationOutput = {
  __typename?: 'ListGoodRelationOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodRelations?: Maybe<Array<GoodRelation>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodReviewInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  goodId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListGoodReviewOutput = {
  __typename?: 'ListGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReviews?: Maybe<Array<GoodReview>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListGoodSuggestionOutput = {
  __typename?: 'ListGoodSuggestionOutput';
  err?: Maybe<Scalars['String']['output']>;
  goods?: Maybe<Array<Good>>;
  ok: Scalars['Boolean']['output'];
};

export type ListInquiryCompleteInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InquiryStatus>;
};

export type ListInquiryCompleteOutput = {
  __typename?: 'ListInquiryCompleteOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiries?: Maybe<Array<Inquiry>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListInquiryInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListInquiryOutput = {
  __typename?: 'ListInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiries?: Maybe<Array<Inquiry>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListLinkServiceInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListLinkServiceNearInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type ListLinkServiceNearOutput = {
  __typename?: 'ListLinkServiceNearOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<Array<LinkService>>;
  ok: Scalars['Boolean']['output'];
};

export type ListLinkServiceOutput = {
  __typename?: 'ListLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<Array<LinkService>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListLinkServiceSelectOutput = {
  __typename?: 'ListLinkServiceSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<Array<LinkService>>;
  ok: Scalars['Boolean']['output'];
};

export type ListMainCategoryOutput = {
  __typename?: 'ListMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  mainCategories?: Maybe<Array<MainCategory>>;
  ok: Scalars['Boolean']['output'];
};

export type ListMyGoodReviewInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListMyGoodReviewOutput = {
  __typename?: 'ListMyGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReviews?: Maybe<Array<GoodReview>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<OrderStatus>>;
};

export type ListOrderKioskDroneOutput = {
  __typename?: 'ListOrderKioskDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderKioskInput = {
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListOrderKioskMeOutput = {
  __typename?: 'ListOrderKioskMeOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderKioskOutput = {
  __typename?: 'ListOrderKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderOutput = {
  __typename?: 'ListOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderReviewOutput = {
  __typename?: 'ListOrderReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
};

export type ListPackEditInput = {
  packId: Scalars['Float']['input'];
};

export type ListPackEditOutput = {
  __typename?: 'ListPackEditOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  packs?: Maybe<Array<Pack>>;
};

export type ListPackInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListPackOrderInput = {
  packId: Scalars['Float']['input'];
};

export type ListPackOrderOutput = {
  __typename?: 'ListPackOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
};

export type ListPackOutput = {
  __typename?: 'ListPackOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  packs?: Maybe<Array<Pack>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListPackSelectOutput = {
  __typename?: 'ListPackSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  packs?: Maybe<Array<Pack>>;
};

export type ListPortByLocationInput = {
  serviceId: Scalars['Float']['input'];
};

export type ListPortByLocationOutput = {
  __typename?: 'ListPortByLocationOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
};

export type ListPortInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListPortOutput = {
  __typename?: 'ListPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListPortPickUpOutput = {
  __typename?: 'ListPortPickUpOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
};

export type ListPortSelectOutput = {
  __typename?: 'ListPortSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
};

export type ListProjectInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListProjectOutput = {
  __typename?: 'ListProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  projects?: Maybe<Array<Project>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListProjectSelectOutput = {
  __typename?: 'ListProjectSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  projects?: Maybe<Array<Project>>;
};

export type ListReceiptInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ReceiptStatus>;
};

export type ListReceiptOutput = {
  __typename?: 'ListReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipts?: Maybe<Array<Receipt>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListReceiptReviewInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ReceiptStatus>;
};

export type ListReceiptReviewOutput = {
  __typename?: 'ListReceiptReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipts?: Maybe<Array<Receipt>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListRelatedGoodInput = {
  goodId: Scalars['Float']['input'];
};

export type ListRelatedGoodOutput = {
  __typename?: 'ListRelatedGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  relatedGoods?: Maybe<Array<Good>>;
};

export type ListSubCategoryInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListSubCategoryOutput = {
  __typename?: 'ListSubCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  subCategories?: Maybe<Array<SubCategory>>;
};

export type ListUserCouponInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListUserCouponOutput = {
  __typename?: 'ListUserCouponOutput';
  coupons?: Maybe<Array<CouponWithAvailability>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListUserKioskInput = {
  digits: Scalars['String']['input'];
};

export type ListUserKioskOutput = {
  __typename?: 'ListUserKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type ListUserSelectOutput = {
  __typename?: 'ListUserSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type LoginInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginKioskInput = {
  id: Scalars['Float']['input'];
  simplePassword?: InputMaybe<Scalars['String']['input']>;
};

export type LoginKioskOutput = {
  __typename?: 'LoginKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type MainCategory = {
  __typename?: 'MainCategory';
  corporations?: Maybe<Array<Corporation>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  upload?: Maybe<Upload>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activeBanner: ActiveBannerOutput;
  activeBannerOption: ActiveBannerOptionOutput;
  cancelReceipt: UpReceiptCancelOutput;
  changeActive: ChangeActiveOutput;
  changeServiceActive: ChangeServiceActiveOutput;
  confirmOrderKiosk: ConfirmOrderKioskOutput;
  crAddress: CrAddressOutput;
  crBanner: CrBannerOutput;
  crBannerMain: CrBannerMainOutput;
  crBannerOption: CrBannerOptionOutput;
  crBasketItem: CrBasketItemOutput;
  crComment: CrCommentOutput;
  crCorporation: CrCorporationOutput;
  crCoupon: CrCouponOutput;
  crDefaultPocket: CrDefaultPocketOutput;
  crDrone: CrDroneOutput;
  crFlight: CrFlightOutput;
  crGood: CrGoodOutput;
  crGoodBulk: CrGoodBulkOutput;
  crGoodDetail: CrGoodDetailOutput;
  crGoodOption: CrGoodOptionOutput;
  crGoodPoster: CrGoodPosterOutput;
  crGoodReview: CrgoodReviewOutput;
  crGoodReviewPoster: CrGoodReviewPosterOutput;
  crInquiry: CrInquiryOutput;
  crInquiryPoster: CrInquiryPosterOutput;
  crLinkService: CrLinkServiceOutput;
  crMainCategory: CrMainCategoryOutput;
  crPack: CrPackOutput;
  crPort: CrPortOutput;
  crProject: CrProjectOutput;
  crReceipt: CrReceiptOutput;
  crSnsUser: CrSnsUserOutput;
  crUser: CrUserOutput;
  crUserCoupon: CrUserCouponOutput;
  delAddress: DelAddressOutput;
  delBanner: DelBannerOutput;
  delBannerMain: DelBannerMainOutput;
  delBasketItem: DelBasketItemOutput;
  delComment: DelCommentOutput;
  delCorporation: DelCorporationOutput;
  delCoupon: DelCouponOutput;
  delDrone: DelDroneOutput;
  delFlight: DelFlightOutput;
  delGood: DelGoodOutput;
  delGoodDetail: DelGoodDetailOutput;
  delGoodOption: DelGoodOptionOutput;
  delGoodPoster: DelGoodPosterOutput;
  delGoodReview: DelGoodReviewOutput;
  delGoodReviewPoster: DelGoodReviewPosterOutput;
  delInquiry: DelInquiryOutput;
  delInquiryPoster: DelInquiryPosterOutput;
  delLinkService: DelLinkServiceOutput;
  delMainCategory: DelMainCategoryOutput;
  delOrder: DelOrderOutput;
  delPack: DelPackOutput;
  delPackOrder: DelPackOrderOutput;
  delPort: DelPortOutput;
  delProject: DelProjectOutput;
  delUser: DelUserOutput;
  editBanner: EditBannerOutput;
  editBannerMain: EditBannerMainOutput;
  editBannerMainIndex: EditBannerMainIndexOutput;
  editBannerOption: EditBannerOptionOutput;
  editBusinessInfo: EditBusinessInfoOutput;
  editComment: EditCommentOutput;
  editCorporation: EditCorporationOutput;
  editCoupon: EditCouponOutput;
  editDrone: EditDroneOutput;
  editExchangeStatus: EditExchangeStatusOutput;
  editFlight: EditFlightOutput;
  editFlightStatus: EditFlightStatusOutput;
  editGood: EditGoodOutput;
  editGoodAttr: EditGoodAttrOutput;
  editGoodAttrInfo: EditGoodAttrInfoOutput;
  editGoodDetail: EditGoodDetailOutput;
  editGoodDetailIndex: EditGoodDetailIndexOutput;
  editGoodOption: EditGoodOptionOutput;
  editGoodOrder: EditGoodOrderOutput;
  editGoodPoster: EditGoodPosterOutput;
  editGoodReview: EditgoodReviewOutput;
  editGoodStatus: EditGoodStatusOutput;
  editGoodsStatus: EditGoodsStatusOutput;
  editInquiry: EditInquiryOutput;
  editInquiryStatus: EditInquiryStatusOutput;
  editLinkService: EditLinkServiceOutput;
  editMainCategory: EditMainCategoryOutput;
  editOrderEndDate: EditOrderEndDateOutput;
  editOrderStatus: EditOrderStatusOutput;
  editOrderStatusDelivered: EditOrderStatusDeliveredOutput;
  editOrderStatusStored: EditOrderStatusStoredOutput;
  editOrderStatusWithQuantity: EditOrderStatusWithQuantityOutput;
  editOrdersStatus: EditOrdersStatusOutput;
  editOrdersStatusDelivered: EditOrdersStatusOutput;
  editOrdersStatusRelease: EditOrdersStatusOutput;
  editPort: EditPortOutput;
  editProject: EditProjectOutput;
  editReceiptAddress: EditReceiptAddressOutput;
  endLoadPocket: EndLoadPocketOutput;
  endSavePocket: EndSavePocketOutput;
  getAddress: GetAddressOutput;
  getJoinUserCertData: GetJoinUserCertOutput;
  getPaymentData: GetPaymentDataOutput;
  getUpUserCertData: GetUpUserCertOutput;
  getUserEmail: GetUserEmailOutput;
  login: LoginOutput;
  loginKiosk: LoginKioskOutput;
  payReceipt: PayReceiptOutput;
  sendChangePasswordEmail: SendChangePasswordEmailOutput;
  setFlightCancel: SetFlightCancelOutput;
  setFlightLand: SetFlightLandOutput;
  setFlightReady: SetFlightReadyOutput;
  setFlightStop: SetFlightStopOutput;
  setFlightTakeOff: SetFlightTakeOffOutput;
  setInquiryComplete: SetInquiryCompleteOutput;
  setInquiryPending: SetInquiryPendingOutput;
  setInquiryPendingRefund: SetInquiryPendingRefundOutput;
  setInquiryRefund: SetInquiryRefundOutput;
  setIsRead: CoreOutput;
  setOrderManager: SetOrderManagerOutput;
  setReceiptDelivered: SetReceiptDeliveredOutput;
  setReceiptHandOut: SetReceiptHandOutOutput;
  setReceiptPending: SetReceiptPendingOutput;
  snsLogin: SnsLoginOutput;
  startLoadPocket: StartLoadPocketOutput;
  startSavePocket: StartSavePocketOutput;
  upAddress: UpAddressOutput;
  upBasketItem: UpBasketItemOutput;
  upGoodDetailURL: UpGoodDetailUrlOutput;
  upReceiptAddress: UpReceiptAddressOutput;
  upUser: UpUserOutput;
  upUserPassword: UpUserPasswordOutput;
};


export type MutationActiveBannerArgs = {
  input: ActiveBannerInput;
};


export type MutationActiveBannerOptionArgs = {
  input: ActiveBannerOptionInput;
};


export type MutationCancelReceiptArgs = {
  input: UpReceiptCancelInput;
};


export type MutationChangeActiveArgs = {
  input: ChangeActiveInput;
};


export type MutationChangeServiceActiveArgs = {
  input: ChangeServiceActiveInput;
};


export type MutationConfirmOrderKioskArgs = {
  input: ConfirmOrderKioskInput;
};


export type MutationCrAddressArgs = {
  input: CrAddressInput;
};


export type MutationCrBannerArgs = {
  input: CrBannerInput;
};


export type MutationCrBannerMainArgs = {
  input: CrBannerMainInput;
};


export type MutationCrBasketItemArgs = {
  input: CrBasketItemInput;
};


export type MutationCrCommentArgs = {
  input: CrCommentInput;
};


export type MutationCrCorporationArgs = {
  input: CrCorporationInput;
};


export type MutationCrCouponArgs = {
  input: CrCouponInput;
};


export type MutationCrDefaultPocketArgs = {
  input: CrDefaultPocketInput;
};


export type MutationCrDroneArgs = {
  input: CrDroneInput;
};


export type MutationCrFlightArgs = {
  input: CrFlightInput;
};


export type MutationCrGoodArgs = {
  input: CrGoodInput;
};


export type MutationCrGoodBulkArgs = {
  input: CrGoodBulkInput;
};


export type MutationCrGoodDetailArgs = {
  input: CrGoodDetailInput;
};


export type MutationCrGoodOptionArgs = {
  input: CrGoodOptionInput;
};


export type MutationCrGoodPosterArgs = {
  input: CrGoodPosterInput;
};


export type MutationCrGoodReviewArgs = {
  input: CrGoodReviewInput;
};


export type MutationCrGoodReviewPosterArgs = {
  input: CrGoodReviewPosterInput;
};


export type MutationCrInquiryArgs = {
  input: CrInquiryInput;
};


export type MutationCrInquiryPosterArgs = {
  input: CrInquiryPosterInput;
};


export type MutationCrLinkServiceArgs = {
  input: CrLinkServiceInput;
};


export type MutationCrMainCategoryArgs = {
  input: CrMainCategoryInput;
};


export type MutationCrPackArgs = {
  input: CrPackInput;
};


export type MutationCrPortArgs = {
  input: CrPortInput;
};


export type MutationCrProjectArgs = {
  input: CrProjectInput;
};


export type MutationCrReceiptArgs = {
  input: CrReceiptInput;
};


export type MutationCrSnsUserArgs = {
  input: CrSnsUserInput;
};


export type MutationCrUserArgs = {
  input: CrUserInput;
};


export type MutationCrUserCouponArgs = {
  input: CrUserCouponInput;
};


export type MutationDelAddressArgs = {
  input: DelAddressInput;
};


export type MutationDelBannerArgs = {
  input: DelBannerInput;
};


export type MutationDelBannerMainArgs = {
  input: DelBannerMainInput;
};


export type MutationDelBasketItemArgs = {
  input: DelBasketItemInput;
};


export type MutationDelCommentArgs = {
  input: DelCommentInput;
};


export type MutationDelCorporationArgs = {
  input: DelCorporationInput;
};


export type MutationDelCouponArgs = {
  input: DelCouponInput;
};


export type MutationDelDroneArgs = {
  input: DelDroneInput;
};


export type MutationDelFlightArgs = {
  input: DelFlightInput;
};


export type MutationDelGoodArgs = {
  input: DelGoodInput;
};


export type MutationDelGoodDetailArgs = {
  input: DelGoodDetailInput;
};


export type MutationDelGoodOptionArgs = {
  input: DelGoodOptionInput;
};


export type MutationDelGoodPosterArgs = {
  input: DelGoodPosterInput;
};


export type MutationDelGoodReviewArgs = {
  input: DelGoodReviewInput;
};


export type MutationDelGoodReviewPosterArgs = {
  input: DelGoodReviewPosterInput;
};


export type MutationDelInquiryArgs = {
  input: DelInquiryInput;
};


export type MutationDelInquiryPosterArgs = {
  input: DelInquiryPosterInput;
};


export type MutationDelLinkServiceArgs = {
  input: DelLinkServiceInput;
};


export type MutationDelMainCategoryArgs = {
  input: DelMainCategoryInput;
};


export type MutationDelOrderArgs = {
  input: DelOrderInput;
};


export type MutationDelPackArgs = {
  input: DelPackInput;
};


export type MutationDelPackOrderArgs = {
  input: DelPackOrderInput;
};


export type MutationDelPortArgs = {
  input: DelPortInput;
};


export type MutationDelProjectArgs = {
  input: DelProjectInput;
};


export type MutationDelUserArgs = {
  input: DelUserInput;
};


export type MutationEditBannerArgs = {
  input: EditBannerInput;
};


export type MutationEditBannerMainArgs = {
  input: EditBannerMainInput;
};


export type MutationEditBannerMainIndexArgs = {
  input: EditBannerMainIndexInput;
};


export type MutationEditBannerOptionArgs = {
  input: EditBannerOptionInput;
};


export type MutationEditBusinessInfoArgs = {
  input: EditBusinessInfoInput;
};


export type MutationEditCommentArgs = {
  input: EditCommentInput;
};


export type MutationEditCorporationArgs = {
  input: EditCorporationInput;
};


export type MutationEditCouponArgs = {
  input: EditCouponInput;
};


export type MutationEditDroneArgs = {
  input: EditDroneInput;
};


export type MutationEditExchangeStatusArgs = {
  input: EditExchangeStatusInput;
};


export type MutationEditFlightArgs = {
  input: EditFlightInput;
};


export type MutationEditFlightStatusArgs = {
  input: EditFlightStatusInput;
};


export type MutationEditGoodArgs = {
  input: EditGoodInput;
};


export type MutationEditGoodAttrArgs = {
  input: EditGoodAttrInput;
};


export type MutationEditGoodAttrInfoArgs = {
  input: EditGoodAttrInfoInput;
};


export type MutationEditGoodDetailArgs = {
  input: EditGoodDetailInput;
};


export type MutationEditGoodDetailIndexArgs = {
  input: EditGoodDetailIndexInput;
};


export type MutationEditGoodOptionArgs = {
  input: EditGoodOptionInput;
};


export type MutationEditGoodOrderArgs = {
  input: EditGoodOrderInput;
};


export type MutationEditGoodPosterArgs = {
  input: EditGoodPosterInput;
};


export type MutationEditGoodReviewArgs = {
  input: EditGoodReviewInput;
};


export type MutationEditGoodStatusArgs = {
  input: EditGoodStatusInput;
};


export type MutationEditGoodsStatusArgs = {
  input: EditGoodsStatusInput;
};


export type MutationEditInquiryArgs = {
  input: EditInquiryInput;
};


export type MutationEditInquiryStatusArgs = {
  input: EditInquiryStatusInput;
};


export type MutationEditLinkServiceArgs = {
  input: EditLinkServiceInput;
};


export type MutationEditMainCategoryArgs = {
  input: EditMainCategoryInput;
};


export type MutationEditOrderEndDateArgs = {
  input: EditOrderEndDateInput;
};


export type MutationEditOrderStatusArgs = {
  input: EditOrderStatusInput;
};


export type MutationEditOrderStatusDeliveredArgs = {
  input: EditOrderStatusDeliveredInput;
};


export type MutationEditOrderStatusStoredArgs = {
  input: EditOrderStatusStoredInput;
};


export type MutationEditOrderStatusWithQuantityArgs = {
  input: EditOrderStatusWithQuantityInput;
};


export type MutationEditOrdersStatusArgs = {
  input: EditOrdersStatusInput;
};


export type MutationEditOrdersStatusDeliveredArgs = {
  input: EditOrdersStatusInput;
};


export type MutationEditOrdersStatusReleaseArgs = {
  input: EditOrdersStatusInput;
};


export type MutationEditPortArgs = {
  input: EditPortInput;
};


export type MutationEditProjectArgs = {
  input: EditProjectInput;
};


export type MutationEditReceiptAddressArgs = {
  input: EditReceiptAddressInput;
};


export type MutationEndLoadPocketArgs = {
  input: EndLoadPocketInput;
};


export type MutationEndSavePocketArgs = {
  input: EndSavePocketInput;
};


export type MutationGetAddressArgs = {
  input: GetAddressInput;
};


export type MutationGetJoinUserCertDataArgs = {
  input: GetJoinUserCertInput;
};


export type MutationGetPaymentDataArgs = {
  input: GetPaymentDataInput;
};


export type MutationGetUpUserCertDataArgs = {
  input: GetUpUserCertInput;
};


export type MutationGetUserEmailArgs = {
  input: GetUserEmailInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginKioskArgs = {
  input: LoginKioskInput;
};


export type MutationPayReceiptArgs = {
  input: PayReceiptInput;
};


export type MutationSendChangePasswordEmailArgs = {
  input: SendChangePasswordEmailInput;
};


export type MutationSetFlightCancelArgs = {
  input: SetFlightCancelInput;
};


export type MutationSetFlightLandArgs = {
  input: SetFlightLandInput;
};


export type MutationSetFlightReadyArgs = {
  input: SetFlightReadyInput;
};


export type MutationSetFlightStopArgs = {
  input: SetFlightStopInput;
};


export type MutationSetFlightTakeOffArgs = {
  input: SetFlightTakeOffInput;
};


export type MutationSetInquiryCompleteArgs = {
  input: SetInquiryCompleteInput;
};


export type MutationSetInquiryPendingArgs = {
  input: SetInquiryPendingInput;
};


export type MutationSetInquiryPendingRefundArgs = {
  input: SetInquiryPendingRefundInput;
};


export type MutationSetInquiryRefundArgs = {
  input: SetInquiryRefundInput;
};


export type MutationSetIsReadArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSetOrderManagerArgs = {
  input: SetOrderManagerInput;
};


export type MutationSetReceiptDeliveredArgs = {
  input: SetReceiptDeliveredInput;
};


export type MutationSetReceiptHandOutArgs = {
  input: SetReceiptHandOutInput;
};


export type MutationSetReceiptPendingArgs = {
  input: SetReceiptPendingInput;
};


export type MutationSnsLoginArgs = {
  input: SnsLoginInput;
};


export type MutationStartLoadPocketArgs = {
  input: StartLoadPocketInput;
};


export type MutationStartSavePocketArgs = {
  input: StartSavePocketInput;
};


export type MutationUpAddressArgs = {
  input: UpAddressInput;
};


export type MutationUpBasketItemArgs = {
  input: UpBasketItemInput;
};


export type MutationUpGoodDetailUrlArgs = {
  input: UpGoodDetailUrlInput;
};


export type MutationUpReceiptAddressArgs = {
  input: UpReceiptAddressInput;
};


export type MutationUpUserArgs = {
  input: UpUserInput;
};


export type MutationUpUserPasswordArgs = {
  input: UpUserPasswordInput;
};

export type Order = {
  __typename?: 'Order';
  EndDate?: Maybe<Scalars['DateTime']['output']>;
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exchangeStatus: ExchangeStatus;
  good?: Maybe<Good>;
  goodName: Scalars['String']['output'];
  goodOption?: Maybe<GoodOption>;
  goodOptionName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  manager?: Maybe<User>;
  orderNum?: Maybe<Scalars['Float']['output']>;
  orderReceipt?: Maybe<OrderReceipt>;
  pack?: Maybe<Pack>;
  pocket?: Maybe<Pocket>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  receipt?: Maybe<Receipt>;
  redelivery?: Maybe<Redelivery>;
  review?: Maybe<GoodReview>;
  status: OrderStatus;
  userCoupons?: Maybe<Array<UserCoupon>>;
};

export type OrderReceipt = {
  __typename?: 'OrderReceipt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goodOption_name?: Maybe<Scalars['String']['output']>;
  good_discountRate?: Maybe<Scalars['Float']['output']>;
  good_poster_url?: Maybe<Scalars['String']['output']>;
  good_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  order_amount?: Maybe<Scalars['Float']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  order_quantity: Scalars['Float']['output'];
};

export enum OrderStatus {
  Bound = 'Bound',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Delivered = 'Delivered',
  Drone = 'Drone',
  Exchange = 'Exchange',
  HandOut = 'HandOut',
  Inspect = 'Inspect',
  Pending = 'Pending',
  PendingDelivered = 'PendingDelivered',
  PendingRefund = 'PendingRefund',
  Port = 'Port',
  Refunded = 'Refunded',
  Stored = 'Stored'
}

export type Pack = {
  __typename?: 'Pack';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  orders?: Maybe<Array<Order>>;
  status?: Maybe<PackStatus>;
};

export enum PackStatus {
  Land = 'Land',
  Pending = 'Pending',
  TakeOff = 'TakeOff'
}

export type PayReceiptInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  paid_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_at?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  pgOption?: InputMaybe<PgOptionInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receiptUuid: Scalars['String']['input'];
  receiver?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userCouponId?: InputMaybe<Scalars['Float']['input']>;
};

export type PayReceiptOutput = {
  __typename?: 'PayReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type PgOption = {
  __typename?: 'PgOption';
  apply_num: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  imp_uid: Scalars['String']['output'];
  merchant_uid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pay_method: Scalars['String']['output'];
  pg_tid: Scalars['String']['output'];
  pg_type: Scalars['String']['output'];
  receipt?: Maybe<Receipt>;
  receipt_url?: Maybe<Scalars['String']['output']>;
};

export type PgOptionInput = {
  apply_num: Scalars['String']['input'];
  imp_uid: Scalars['String']['input'];
  merchant_uid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pay_method: Scalars['String']['input'];
  pg_tid: Scalars['String']['input'];
  pg_type: Scalars['String']['input'];
  receipt_url?: InputMaybe<Scalars['String']['input']>;
};

export type Pocket = {
  __typename?: 'Pocket';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  order?: Maybe<Order>;
  port: Port;
  status: PocketStatus;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum PocketStatus {
  Empty = 'Empty',
  Full = 'Full',
  Repair = 'Repair',
  Running = 'Running'
}

export type Port = {
  __typename?: 'Port';
  address?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<Address>>;
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryRegion: Scalars['Boolean']['output'];
  flightFroms?: Maybe<Array<Flight>>;
  flightTos?: Maybe<Array<Flight>>;
  id: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  linkService?: Maybe<LinkService>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pickUp: Scalars['Boolean']['output'];
  pockets?: Maybe<Array<Pocket>>;
  project?: Maybe<Project>;
  receipts?: Maybe<Array<Receipt>>;
  regionKeyWord?: Maybe<Array<Scalars['String']['output']>>;
  status: PortStatus;
  usageTime?: Maybe<Scalars['String']['output']>;
};

export enum PortStatus {
  Operating = 'Operating',
  Pending = 'Pending',
  Repair = 'Repair'
}

export type Project = {
  __typename?: 'Project';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  ports?: Maybe<Array<Port>>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ProjectStatus>;
};

export enum ProjectStatus {
  Completed = 'Completed',
  On = 'On',
  Pending = 'Pending'
}

export type Query = {
  __typename?: 'Query';
  changeGood: ChangeOutput;
  changeOrder: ChangeOrderOutput;
  chkAddressArea: ChkAddressAreaOutput;
  getBanner: GetBannerOutput;
  getBannerMain: GetBannerMainOutput;
  getBannerMainActive: GetBannerMainActiveOutput;
  getBannerMainEvent: GetBannerMainEventOutput;
  getBannerOptionActive: GetBannerOptionActiveOutput;
  getCorporation: GetCorporationOutput;
  getCorporationCategory: GetCorporationCategoryOutput;
  getCoupon: GetCouponOutput;
  getDrone: GetDroneOutput;
  getFlight: GetFlightOutput;
  getGood: GetGoodOutput;
  getGoodReview: GetGoodReviewOutput;
  getInquiry: GetInquiryOutput;
  getKakaoEmail: GetKakaoEmailOutput;
  getLinkService: GetLinkServiceOutput;
  getLinkServiceNear: GetLinkServiceNearOutput;
  getMainCategory: GetMainCategoryOutput;
  getOrder: GetOrderOutput;
  getPgOption: GetPgOptionOutput;
  getPort: GetPortOutput;
  getProject: GetProjectOutput;
  getReceipt: GetReceiptOutput;
  listAddress: ListAddressOutput;
  listBanner: ListBannerOutput;
  listBannerMain: ListBannerMainOutput;
  listBannerOption: ListBannerOptionOutput;
  listBasketItem: ListBasketItemOutput;
  listBasketItemService: ListBasketItemServiceOutput;
  listComment: ListCommentOutput;
  listCorporation: ListCorporationOutput;
  listCorporationByLocation: ListCorporationByLocationOutput;
  listCorporationSelect: ListCorporationSelectOutput;
  listCoupon: ListCouponOutput;
  listCouponCorporation: ListCouponCorporationOutput;
  listCouponLocation: ListCouponLocationOutput;
  listDriverSelect: ListDriverSelectOutput;
  listDrone: ListDroneOutput;
  listDroneSelect: ListDroneSelectOutput;
  listFlight: ListFlightOutput;
  listGood: ListGoodOutput;
  listGoodAll: ListGoodAllOutput;
  listGoodDetail: ListGoodDetailOutput;
  listGoodOption: ListGoodOptionOutput;
  listGoodPoster: ListGoodPosterOutput;
  listGoodRelation: ListGoodRelationOutput;
  listGoodReview: ListGoodReviewOutput;
  listGoodSuggestion: ListGoodSuggestionOutput;
  listInquiry: ListInquiryOutput;
  listInquiryComplete: ListInquiryCompleteOutput;
  listLinkService: ListLinkServiceOutput;
  listLinkServiceNear: ListLinkServiceNearOutput;
  listLinkServiceSelect: ListLinkServiceSelectOutput;
  listMainCategory: ListMainCategoryOutput;
  listMyGoodReview: ListMyGoodReviewOutput;
  listOrder: ListOrderOutput;
  listOrderKiosk: ListOrderKioskOutput;
  listOrderKioskDrone: ListOrderKioskDroneOutput;
  listOrderKioskMe: ListOrderKioskMeOutput;
  listOrderReview: ListOrderReviewOutput;
  listPack: ListPackOutput;
  listPackEdit: ListPackEditOutput;
  listPackOrder: ListPackOrderOutput;
  listPackSelect: ListPackSelectOutput;
  listPort: ListPortOutput;
  listPortByLocation: ListPortByLocationOutput;
  listPortPickup: ListPortPickUpOutput;
  listPortSelect: ListPortSelectOutput;
  listProject: ListProjectOutput;
  listProjectSelect: ListProjectSelectOutput;
  listReceipt: ListReceiptOutput;
  listReceiptReview: ListReceiptReviewOutput;
  listRelatedGoods: ListRelatedGoodOutput;
  listSubCategory: ListSubCategoryOutput;
  listUserCoupon: ListUserCouponOutput;
  listUserKiosk: ListUserKioskOutput;
  listUserSelect: ListUserSelectOutput;
  makeOrderReceipt: CrOrderReceiptOutput;
  me: User;
};


export type QueryChkAddressAreaArgs = {
  input: ChkAddressAreaInput;
};


export type QueryGetBannerArgs = {
  input: GetBannerInput;
};


export type QueryGetBannerMainArgs = {
  input: GetBannerMainInput;
};


export type QueryGetBannerMainActiveArgs = {
  input: GetBannerMainActiveInput;
};


export type QueryGetBannerMainEventArgs = {
  input: GetBannerMainEventInput;
};


export type QueryGetCorporationArgs = {
  input: GetCorporationInput;
};


export type QueryGetCorporationCategoryArgs = {
  input: GetCorporationCategoryInput;
};


export type QueryGetCouponArgs = {
  input: GetCouponInput;
};


export type QueryGetDroneArgs = {
  input: GetDroneInput;
};


export type QueryGetFlightArgs = {
  input: GetFlightInput;
};


export type QueryGetGoodArgs = {
  input: GetGoodInput;
};


export type QueryGetGoodReviewArgs = {
  input: GetGoodReviewInput;
};


export type QueryGetInquiryArgs = {
  input: GetInquiryInput;
};


export type QueryGetKakaoEmailArgs = {
  input: GetKakaoEmailInput;
};


export type QueryGetLinkServiceArgs = {
  input: GetLinkServiceInput;
};


export type QueryGetLinkServiceNearArgs = {
  input: GetLinkServiceNearInput;
};


export type QueryGetMainCategoryArgs = {
  input: GetMainCategoryInput;
};


export type QueryGetOrderArgs = {
  input: GetOrderInput;
};


export type QueryGetPgOptionArgs = {
  input: GetPgOptionInput;
};


export type QueryGetPortArgs = {
  input: GetPortInput;
};


export type QueryGetProjectArgs = {
  input: GetProjectInput;
};


export type QueryGetReceiptArgs = {
  input: GetReceiptInput;
};


export type QueryListBannerArgs = {
  input: ListBannerInput;
};


export type QueryListBannerMainArgs = {
  input: ListBannerMainInput;
};


export type QueryListBasketItemServiceArgs = {
  input: ListBasketItemServiceInput;
};


export type QueryListCommentArgs = {
  input: ListCommentInput;
};


export type QueryListCorporationArgs = {
  input: ListCorporationInput;
};


export type QueryListCorporationByLocationArgs = {
  input: ListCorporationByLocationInput;
};


export type QueryListCouponArgs = {
  input: ListCouponInput;
};


export type QueryListCouponCorporationArgs = {
  input: ListCouponCorporationInput;
};


export type QueryListCouponLocationArgs = {
  input: ListCouponLocationInput;
};


export type QueryListDroneArgs = {
  input: ListDroneInput;
};


export type QueryListFlightArgs = {
  input: ListFlightInput;
};


export type QueryListGoodArgs = {
  input: ListGoodInput;
};


export type QueryListGoodDetailArgs = {
  input: ListGoodDetailInput;
};


export type QueryListGoodOptionArgs = {
  input: ListGoodOptionInput;
};


export type QueryListGoodPosterArgs = {
  input: ListGoodPosterInput;
};


export type QueryListGoodRelationArgs = {
  input: ListGoodRelationInput;
};


export type QueryListGoodReviewArgs = {
  input: ListGoodReviewInput;
};


export type QueryListInquiryArgs = {
  input: ListInquiryInput;
};


export type QueryListInquiryCompleteArgs = {
  input: ListInquiryCompleteInput;
};


export type QueryListLinkServiceArgs = {
  input: ListLinkServiceInput;
};


export type QueryListLinkServiceNearArgs = {
  input: ListLinkServiceNearInput;
};


export type QueryListMyGoodReviewArgs = {
  input: ListMyGoodReviewInput;
};


export type QueryListOrderArgs = {
  input: ListOrderInput;
};


export type QueryListOrderKioskArgs = {
  input: ListOrderKioskInput;
};


export type QueryListPackArgs = {
  input: ListPackInput;
};


export type QueryListPackEditArgs = {
  input: ListPackEditInput;
};


export type QueryListPackOrderArgs = {
  input: ListPackOrderInput;
};


export type QueryListPortArgs = {
  input: ListPortInput;
};


export type QueryListPortByLocationArgs = {
  input: ListPortByLocationInput;
};


export type QueryListProjectArgs = {
  input: ListProjectInput;
};


export type QueryListReceiptArgs = {
  input: ListReceiptInput;
};


export type QueryListReceiptReviewArgs = {
  input: ListReceiptReviewInput;
};


export type QueryListRelatedGoodsArgs = {
  input: ListRelatedGoodInput;
};


export type QueryListSubCategoryArgs = {
  input: ListSubCategoryInput;
};


export type QueryListUserCouponArgs = {
  input: ListUserCouponInput;
};


export type QueryListUserKioskArgs = {
  input: ListUserKioskInput;
};

export type Receipt = {
  __typename?: 'Receipt';
  address?: Maybe<Scalars['String']['output']>;
  basketItems?: Maybe<Array<BasketItem>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  howToReceive?: Maybe<HowToReceive>;
  id: Scalars['Float']['output'];
  inquiries?: Maybe<Array<Inquiry>>;
  isBilled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Order>>;
  paid_amount?: Maybe<Scalars['Float']['output']>;
  paid_at?: Maybe<Scalars['String']['output']>;
  pass?: Maybe<Scalars['String']['output']>;
  pgOption?: Maybe<PgOption>;
  phone?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Port>;
  receiptNum?: Maybe<Scalars['String']['output']>;
  receiptStatus: ReceiptStatus;
  receiver?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum ReceiptStatus {
  Canceled = 'Canceled',
  Delivered = 'Delivered',
  HandOut = 'HandOut',
  Pending = 'Pending',
  Refund = 'Refund',
  Uncharged = 'Uncharged'
}

export enum Redelivery {
  None = 'None',
  Redelivery = 'Redelivery'
}

export enum Sns {
  Google = 'Google',
  Kakao = 'Kakao',
  Nilivery = 'Nilivery'
}

export type SendChangePasswordEmailInput = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SendChangePasswordEmailOutput = {
  __typename?: 'SendChangePasswordEmailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightCancelInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightCancelOutput = {
  __typename?: 'SetFlightCancelOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightLandInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightLandOutput = {
  __typename?: 'SetFlightLandOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightReadyInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightReadyOutput = {
  __typename?: 'SetFlightReadyOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightStopInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightStopOutput = {
  __typename?: 'SetFlightStopOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightTakeOffInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightTakeOffOutput = {
  __typename?: 'SetFlightTakeOffOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryCompleteInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryCompleteOutput = {
  __typename?: 'SetInquiryCompleteOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryPendingInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryPendingOutput = {
  __typename?: 'SetInquiryPendingOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryPendingRefundInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryPendingRefundOutput = {
  __typename?: 'SetInquiryPendingRefundOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryRefundInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryRefundOutput = {
  __typename?: 'SetInquiryRefundOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetOrderManagerInput = {
  orderId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};

export type SetOrderManagerOutput = {
  __typename?: 'SetOrderManagerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetReceiptDeliveredInput = {
  receiptId: Scalars['Float']['input'];
};

export type SetReceiptDeliveredOutput = {
  __typename?: 'SetReceiptDeliveredOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetReceiptHandOutInput = {
  receiptId: Scalars['Float']['input'];
};

export type SetReceiptHandOutOutput = {
  __typename?: 'SetReceiptHandOutOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetReceiptPendingInput = {
  receiptId: Scalars['Float']['input'];
};

export type SetReceiptPendingOutput = {
  __typename?: 'SetReceiptPendingOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SnsLoginInput = {
  sns?: InputMaybe<Sns>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SnsLoginOutput = {
  __typename?: 'SnsLoginOutput';
  err?: Maybe<Scalars['String']['output']>;
  exist?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type StartLoadPocketInput = {
  orderId: Scalars['Float']['input'];
};

export type StartLoadPocketOutput = {
  __typename?: 'StartLoadPocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pocket?: Maybe<Pocket>;
};

export type StartSavePocketInput = {
  orderId: Scalars['Float']['input'];
  portId: Scalars['Float']['input'];
};

export type StartSavePocketOutput = {
  __typename?: 'StartSavePocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pocket?: Maybe<Pocket>;
};

export type SubCategory = {
  __typename?: 'SubCategory';
  corporation?: Maybe<Corporation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goods?: Maybe<Array<Good>>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  newOrderList: Array<Order>;
  pendingStartSavePocket: Pocket;
};

export enum Tags {
  Accessories = 'Accessories',
  Cafe = 'Cafe',
  Camping = 'Camping',
  Chicken = 'Chicken',
  DeliveryDate = 'DeliveryDate',
  Dessert = 'Dessert',
  EcoFriendly = 'EcoFriendly',
  Emart = 'Emart',
  EventProduct = 'EventProduct',
  EventTag = 'EventTag',
  GroupPurchase = 'GroupPurchase',
  LocalFood = 'LocalFood',
  Meal = 'Meal',
  Mealkit = 'Mealkit',
  NationalFood = 'NationalFood',
  NiliGroupPurchase = 'NiliGroupPurchase',
  OutdoorGear = 'OutdoorGear',
  Popularity = 'Popularity',
  Safety = 'Safety',
  Subsidiary = 'Subsidiary',
  Suggestion = 'Suggestion',
  TodayMeal = 'TodayMeal'
}

export type UpAddressInput = {
  isRep?: InputMaybe<Scalars['Boolean']['input']>;
  mainAddress?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subAddress?: InputMaybe<Scalars['String']['input']>;
  upAddressId?: InputMaybe<Scalars['Float']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpAddressOutput = {
  __typename?: 'UpAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpBasketItemInput = {
  basketItemId: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpBasketItemOutput = {
  __typename?: 'UpBasketItemOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpGoodDetailUrlInput = {
  id: Scalars['Float']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpGoodDetailUrlOutput = {
  __typename?: 'UpGoodDetailURLOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpReceiptAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  howToReceive?: InputMaybe<HowToReceive>;
  message?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  portId?: InputMaybe<Scalars['Float']['input']>;
  receiptUuid: Scalars['String']['input'];
  receiver?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type UpReceiptAddressOutput = {
  __typename?: 'UpReceiptAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type UpReceiptCancelInput = {
  id: Scalars['Float']['input'];
};

export type UpReceiptCancelOutput = {
  __typename?: 'UpReceiptCancelOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpUserInput = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type UpUserOutput = {
  __typename?: 'UpUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpUserPasswordInput = {
  newPassword: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpUserPasswordOutput = {
  __typename?: 'UpUserPasswordOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Upload = {
  __typename?: 'Upload';
  bannerMain?: Maybe<BannerMain>;
  bannerOptions?: Maybe<BannerOption>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<BannerMainEvent>;
  filename: Scalars['String']['output'];
  goodDetail?: Maybe<GoodDetail>;
  goodPoster?: Maybe<GoodPoster>;
  goodReviewPoster?: Maybe<GoodReviewPoster>;
  id: Scalars['Float']['output'];
  inquiryPoster?: Maybe<InquiryPoster>;
  isUsing: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  mainCategory?: Maybe<MainCategory>;
  mimetype: Scalars['String']['output'];
  uploader: User;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  addresses?: Maybe<Array<Address>>;
  basketItems?: Maybe<Array<BasketItem>>;
  certification?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Array<Comment>>;
  corporations?: Maybe<Array<Corporation>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  drones?: Maybe<Array<Drone>>;
  files?: Maybe<Array<Upload>>;
  flightFroms?: Maybe<Array<Flight>>;
  flightTos?: Maybe<Array<Flight>>;
  flights?: Maybe<Array<Flight>>;
  goods?: Maybe<Array<Good>>;
  id: Scalars['Float']['output'];
  inquiries?: Maybe<Array<Inquiry>>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  managerInquiries?: Maybe<Array<Inquiry>>;
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Order>>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pushId?: Maybe<Scalars['String']['output']>;
  receipts?: Maybe<Array<Receipt>>;
  reviews?: Maybe<Array<GoodReview>>;
  role: UserRole;
  simplePassword?: Maybe<Scalars['String']['output']>;
  sns?: Maybe<Sns>;
  type?: Maybe<UserType>;
  userCoupons?: Maybe<Array<UserCoupon>>;
  username?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<WorkerType>;
};

export type UserCoupon = {
  __typename?: 'UserCoupon';
  coupon: Coupon;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  status: UserCouponStatus;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedInOrder?: Maybe<Order>;
  user: User;
};

export enum UserCouponStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Used = 'USED'
}

export enum UserRole {
  Admin = 'Admin',
  General = 'General',
  Worker = 'Worker'
}

export enum UserType {
  Test = 'Test'
}

export enum WorkerType {
  Driver = 'Driver',
  Packer = 'Packer',
  Pilot = 'Pilot'
}

export type GetBannerMainEventOutput = {
  __typename?: 'getBannerMainEventOutput';
  bannerMainEvent?: Maybe<BannerMainEvent>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerMainOutput = {
  __typename?: 'getBannerMainOutput';
  bannerMain?: Maybe<BannerMain>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChkAddressAreaQueryVariables = Exact<{
  input: ChkAddressAreaInput;
}>;


export type ChkAddressAreaQuery = { __typename?: 'Query', chkAddressArea: { __typename?: 'ChkAddressAreaOutput', ok: boolean, err?: string | null, deliveryArea?: boolean | null } };

export type CrAddressMutationVariables = Exact<{
  input: CrAddressInput;
}>;


export type CrAddressMutation = { __typename?: 'Mutation', crAddress: { __typename?: 'CrAddressOutput', ok: boolean, err?: string | null, addressId?: number | null } };

export type CrBasketItemMutationVariables = Exact<{
  input: CrBasketItemInput;
}>;


export type CrBasketItemMutation = { __typename?: 'Mutation', crBasketItem: { __typename?: 'CrBasketItemOutput', ok: boolean, err?: string | null } };

export type CrGoodReviewMutationVariables = Exact<{
  input: CrGoodReviewInput;
}>;


export type CrGoodReviewMutation = { __typename?: 'Mutation', crGoodReview: { __typename?: 'CrgoodReviewOutput', ok: boolean, err?: string | null } };

export type CrGoodReviewPosterMutationVariables = Exact<{
  input: CrGoodReviewPosterInput;
}>;


export type CrGoodReviewPosterMutation = { __typename?: 'Mutation', crGoodReviewPoster: { __typename?: 'CrGoodReviewPosterOutput', ok: boolean, err?: string | null, goodReviewPoster?: { __typename?: 'GoodReviewPoster', id: number, upload?: { __typename?: 'Upload', uuid?: string | null, url?: string | null } | null } | null } };

export type CrInquiryMutationVariables = Exact<{
  input: CrInquiryInput;
}>;


export type CrInquiryMutation = { __typename?: 'Mutation', crInquiry: { __typename?: 'CrInquiryOutput', ok: boolean, err?: string | null } };

export type CrInquiryPosterMutationVariables = Exact<{
  input: CrInquiryPosterInput;
}>;


export type CrInquiryPosterMutation = { __typename?: 'Mutation', crInquiryPoster: { __typename?: 'CrInquiryPosterOutput', ok: boolean, err?: string | null, inquiryPoster?: { __typename?: 'InquiryPoster', id: number, index: number, upload?: { __typename?: 'Upload', url?: string | null, uuid?: string | null } | null } | null } };

export type CrReceiptMutationVariables = Exact<{
  input: CrReceiptInput;
}>;


export type CrReceiptMutation = { __typename?: 'Mutation', crReceipt: { __typename?: 'CrReceiptOutput', ok: boolean, err?: string | null, receipt?: { __typename?: 'Receipt', id: number, uuid?: string | null } | null } };

export type CrSnsUserMutationVariables = Exact<{
  input: CrSnsUserInput;
}>;


export type CrSnsUserMutation = { __typename?: 'Mutation', crSnsUser: { __typename?: 'CrSnsUserOutput', ok: boolean, err?: string | null, token?: string | null, id?: number | null } };

export type CrUserMutationVariables = Exact<{
  input: CrUserInput;
}>;


export type CrUserMutation = { __typename?: 'Mutation', crUser: { __typename?: 'CrUserOutput', ok: boolean, id?: number | null, err?: string | null } };

export type CrUserCouponMutationVariables = Exact<{
  input: CrUserCouponInput;
}>;


export type CrUserCouponMutation = { __typename?: 'Mutation', crUserCoupon: { __typename?: 'CrUserCouponOutput', ok: boolean, err?: string | null } };

export type DelAddressMutationVariables = Exact<{
  input: DelAddressInput;
}>;


export type DelAddressMutation = { __typename?: 'Mutation', delAddress: { __typename?: 'DelAddressOutput', ok: boolean, err?: string | null } };

export type DelBasketItemMutationVariables = Exact<{
  input: DelBasketItemInput;
}>;


export type DelBasketItemMutation = { __typename?: 'Mutation', delBasketItem: { __typename?: 'DelBasketItemOutput', ok: boolean, err?: string | null } };

export type DelGoodReviewMutationVariables = Exact<{
  input: DelGoodReviewInput;
}>;


export type DelGoodReviewMutation = { __typename?: 'Mutation', delGoodReview: { __typename?: 'DelGoodReviewOutput', ok: boolean, err?: string | null } };

export type DelGoodReviewPosterMutationVariables = Exact<{
  input: DelGoodReviewPosterInput;
}>;


export type DelGoodReviewPosterMutation = { __typename?: 'Mutation', delGoodReviewPoster: { __typename?: 'DelGoodReviewPosterOutput', ok: boolean, err?: string | null } };

export type DelInquiryPosterMutationVariables = Exact<{
  input: DelInquiryPosterInput;
}>;


export type DelInquiryPosterMutation = { __typename?: 'Mutation', delInquiryPoster: { __typename?: 'DelInquiryPosterOutput', ok: boolean, err?: string | null } };

export type DelUserMutationVariables = Exact<{
  input: DelUserInput;
}>;


export type DelUserMutation = { __typename?: 'Mutation', delUser: { __typename?: 'DelUserOutput', ok: boolean, err?: string | null } };

export type GetAddressMutationVariables = Exact<{
  input: GetAddressInput;
}>;


export type GetAddressMutation = { __typename?: 'Mutation', getAddress: { __typename?: 'GetAddressOutput', ok: boolean, err?: string | null, address?: { __typename?: 'Address', id: number, username?: string | null, name?: string | null, phone?: string | null, zoneCode?: string | null, region?: string | null, mainAddress?: string | null, subAddress?: string | null, message?: string | null, pass?: string | null, isRep: boolean } | null } };

export type GetBannerMainActiveQueryVariables = Exact<{
  input: GetBannerMainActiveInput;
}>;


export type GetBannerMainActiveQuery = { __typename?: 'Query', getBannerMainActive: { __typename?: 'GetBannerMainActiveOutput', ok: boolean, err?: string | null, bannerMain?: Array<{ __typename?: 'BannerMain', id: number, index: number, link?: string | null, mainType?: BannerMainType | null, title?: string | null, note?: string | null, alt?: string | null, isFree: boolean, isRes: boolean, isEvent: boolean, isOnePlusOne: boolean, linkServices?: Array<{ __typename?: 'LinkService', id: number, name: string, link?: string | null }> | null, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null } | null, event?: { __typename?: 'BannerMainEvent', id: number, title?: string | null, link?: string | null, isActive: boolean, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null } | null } | null }> | null } };

export type GetBannerMainEventQueryVariables = Exact<{
  input: GetBannerMainEventInput;
}>;


export type GetBannerMainEventQuery = { __typename?: 'Query', getBannerMainEvent: { __typename?: 'getBannerMainEventOutput', ok: boolean, err?: string | null, bannerMainEvent?: { __typename?: 'BannerMainEvent', id: number, title?: string | null, link?: string | null, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null } | null } | null } };

export type GetBannerOptionActiveQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBannerOptionActiveQuery = { __typename?: 'Query', getBannerOptionActive: { __typename?: 'GetBannerOptionActiveOutput', ok: boolean, err?: string | null, bannerOption?: Array<{ __typename?: 'BannerOption', id: number, index: number, link?: string | null, title?: string | null, note?: string | null, alt?: string | null, isFree: boolean, isRes: boolean, isEvent: boolean, isOnePlusOne: boolean, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null } | null }> | null } };

export type GetCorporationQueryVariables = Exact<{
  input: GetCorporationInput;
}>;


export type GetCorporationQuery = { __typename?: 'Query', getCorporation: { __typename?: 'GetCorporationOutput', ok: boolean, err?: string | null, corporation?: { __typename?: 'Corporation', id: number, name: string, address?: string | null, isActive: boolean, operationFrom?: string | null, operationTo?: string | null, holiday?: string | null, ceoName?: string | null, origin?: string | null, businessName?: string | null, businessNumber?: string | null, businessAddress?: string | null, mainCategories?: Array<{ __typename?: 'MainCategory', id: number, name: string, imageUrl?: string | null }> | null, coupons?: Array<{ __typename?: 'Coupon', id: number, name: string, status: CouponStatus, discountPrice?: number | null, validFrom: any, validUntil: any, userCoupons?: Array<{ __typename?: 'UserCoupon', id: number, status: UserCouponStatus }> | null }> | null, goods?: Array<{ __typename?: 'Good', id: number, title: string, summary?: string | null, price?: number | null, discountRate?: number | null, status: GoodStatus, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodReviews?: Array<{ __typename?: 'GoodReview', id: number, rating: number, note: string }> | null, subCategory?: { __typename?: 'SubCategory', id: number, name: string } | null }> | null } | null } };

export type GetCorporationCategoryQueryVariables = Exact<{
  input: GetCorporationCategoryInput;
}>;


export type GetCorporationCategoryQuery = { __typename?: 'Query', getCorporationCategory: { __typename?: 'GetCorporationCategoryOutput', ok: boolean, err?: string | null, subCategories?: Array<{ __typename?: 'SubCategory', id: number, name: string }> | null } };

export type GetGoodQueryVariables = Exact<{
  input: GetGoodInput;
}>;


export type GetGoodQuery = { __typename?: 'Query', getGood: { __typename?: 'GetGoodOutput', ok: boolean, err?: string | null, good?: { __typename?: 'Good', id: number, price?: number | null, discountRate?: number | null, attributeSet?: string | null, goodAttrInfo?: string | null, status: GoodStatus, limitNumOrders: number, tags?: Array<Tags> | null, title: string, summary?: string | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, name?: string | null, index?: number | null, count?: number | null, deliveryDate?: any | null, price?: number | null, discountRate?: number | null }> | null, corporation?: { __typename?: 'Corporation', id: number, name: string, isActive: boolean } | null, goodReviews?: Array<{ __typename?: 'GoodReview', id: number, note: string, rating: number, goodReviewPosters?: Array<{ __typename?: 'GoodReviewPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }> | null, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodDetails?: Array<{ __typename?: 'GoodDetail', id: number, index: number, note?: string | null, url?: string | null, detailType?: GoodDetailType | null, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodRelations?: Array<{ __typename?: 'GoodRelation', id: number, index?: number | null, relatedGoods?: Array<{ __typename?: 'Good', id: number, title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }> | null }> | null } | null } };

export type GetGoodReviewQueryVariables = Exact<{
  input: GetGoodReviewInput;
}>;


export type GetGoodReviewQuery = { __typename?: 'Query', getGoodReview: { __typename?: 'GetGoodReviewOutput', ok: boolean, err?: string | null, goodReview?: { __typename?: 'GoodReview', id: number, createdAt?: any | null, note: string, rating: number, author?: { __typename?: 'User', id: number, name?: string | null, username?: string | null } | null, good: { __typename?: 'Good', corporation?: { __typename?: 'Corporation', name: string } | null }, order?: { __typename?: 'Order', id: number, orderReceipt?: { __typename?: 'OrderReceipt', good_poster_url?: string | null, good_title?: string | null } | null } | null, goodReviewPosters?: Array<{ __typename?: 'GoodReviewPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } | null } };

export type GetInquiryQueryVariables = Exact<{
  input: GetInquiryInput;
}>;


export type GetInquiryQuery = { __typename?: 'Query', getInquiry: { __typename?: 'GetInquiryOutput', ok: boolean, err?: string | null, inquiry?: { __typename?: 'Inquiry', id: number, title: string, note: string, status: InquiryStatus, type: InquiryType, author: { __typename?: 'User', id: number, name?: string | null, username?: string | null }, comments?: Array<{ __typename?: 'Comment', id: number, createdAt?: any | null, note: string }> | null, inquiryPosters?: Array<{ __typename?: 'InquiryPoster', id: number, index: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } | null } };

export type GetJoinUserCertDataMutationVariables = Exact<{
  input: GetJoinUserCertInput;
}>;


export type GetJoinUserCertDataMutation = { __typename?: 'Mutation', getJoinUserCertData: { __typename?: 'GetJoinUserCertOutput', ok: boolean, err?: string | null, token?: string | null } };

export type GetKakaoEmailQueryVariables = Exact<{
  input: GetKakaoEmailInput;
}>;


export type GetKakaoEmailQuery = { __typename?: 'Query', getKakaoEmail: { __typename?: 'GetKakaoEmailOutput', ok: boolean, err?: string | null, email?: string | null } };

export type GetLinkServiceQueryVariables = Exact<{
  input: GetLinkServiceInput;
}>;


export type GetLinkServiceQuery = { __typename?: 'Query', getLinkService: { __typename?: 'GetLinkServiceOutput', ok: boolean, err?: string | null, linkService?: { __typename?: 'LinkService', id: number, name: string, minAmount?: number | null } | null } };

export type GetLinkServiceNearQueryVariables = Exact<{
  input: GetLinkServiceNearInput;
}>;


export type GetLinkServiceNearQuery = { __typename?: 'Query', getLinkServiceNear: { __typename?: 'GetLinkServiceNearOutput', ok: boolean, err?: string | null, linkservice?: { __typename?: 'LinkService', id: number, name: string, link?: string | null, description?: string | null, latitude?: number | null, longitude?: number | null, address?: string | null, distance?: number | null, isActive: boolean } | null } };

export type GetOrderQueryVariables = Exact<{
  input: GetOrderInput;
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder: { __typename?: 'GetOrderOutput', ok: boolean, err?: string | null, order: { __typename?: 'Order', id: number, goodName: string, goodOptionName?: string | null, price?: number | null, quantity: number, exchangeStatus: ExchangeStatus, redelivery?: Redelivery | null, status: OrderStatus, amount: number, orderReceipt?: { __typename?: 'OrderReceipt', id: number, order_quantity: number, good_discountRate?: number | null, order_price?: number | null, goodOption_name?: string | null, good_title?: string | null, good_poster_url?: string | null } | null, receipt?: { __typename?: 'Receipt', howToReceive?: HowToReceive | null, port?: { __typename?: 'Port', name: string, phone?: string | null, address?: string | null, usageTime?: string | null } | null } | null, manager?: { __typename?: 'User', id: number, name?: string | null } | null, review?: { __typename?: 'GoodReview', id: number } | null, good?: { __typename?: 'Good', id: number, status: GoodStatus, title: string, summary?: string | null, subCategory?: { __typename?: 'SubCategory', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number }> | null } | null } } };

export type GetPaymentDataMutationVariables = Exact<{
  input: GetPaymentDataInput;
}>;


export type GetPaymentDataMutation = { __typename?: 'Mutation', getPaymentData: { __typename?: 'GetPaymentDataOutput', ok: boolean, err?: string | null, receipt?: { __typename?: 'Receipt', basketItems?: Array<{ __typename?: 'BasketItem', quantity: number, good: { __typename?: 'Good', title: string, price?: number | null, discountRate?: number | null, goodPosters?: Array<{ __typename?: 'GoodPoster', isRep: boolean, index: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number }> | null } }> | null, orders?: Array<{ __typename?: 'Order', quantity: number, price?: number | null, amount: number, goodName: string, goodOptionName?: string | null, good?: { __typename?: 'Good', title: string, price?: number | null, discountRate?: number | null, goodPosters?: Array<{ __typename?: 'GoodPoster', isRep: boolean, index: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number }> | null } | null }> | null } | null } };

export type GetPgOptionQueryVariables = Exact<{
  input: GetPgOptionInput;
}>;


export type GetPgOptionQuery = { __typename?: 'Query', getPgOption: { __typename?: 'GetPgOptionOutput', ok: boolean, err?: string | null, pgOption?: { __typename?: 'PgOption', id: number, receipt_url?: string | null, receipt?: { __typename?: 'Receipt', id: number } | null } | null } };

export type GetReceiptQueryVariables = Exact<{
  input: GetReceiptInput;
}>;


export type GetReceiptQuery = { __typename?: 'Query', getReceipt: { __typename?: 'GetReceiptOutput', ok: boolean, err?: string | null, deliveryFee?: number | null, receipt?: { __typename?: 'Receipt', id: number, howToReceive?: HowToReceive | null, address?: string | null, message?: string | null, pass?: string | null, phone?: string | null, receiver?: string | null, paid_amount?: number | null, port?: { __typename?: 'Port', name: string, usageTime?: string | null, phone?: string | null, address?: string | null, author?: { __typename?: 'User', id: number, name?: string | null, phone?: string | null } | null } | null, basketItems?: Array<{ __typename?: 'BasketItem', id: number, quantity: number, good: { __typename?: 'Good', title: string, price?: number | null, discountRate?: number | null, goodPosters?: Array<{ __typename?: 'GoodPoster', isRep: boolean, index: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }, goodOption?: { __typename?: 'GoodOption', name?: string | null, price?: number | null, discountRate?: number | null } | null }> | null, orders?: Array<{ __typename?: 'Order', quantity: number, price?: number | null, amount: number, goodName: string, goodOptionName?: string | null, good?: { __typename?: 'Good', price?: number | null, discountRate?: number | null, title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', isRep: boolean, index: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number }> | null } | null }> | null } | null } };

export type GetUpUserCertDataMutationVariables = Exact<{
  input: GetUpUserCertInput;
}>;


export type GetUpUserCertDataMutation = { __typename?: 'Mutation', getUpUserCertData: { __typename?: 'GetUpUserCertOutput', ok: boolean, err?: string | null, user?: { __typename?: 'User', name?: string | null, phone?: string | null, username?: string | null, id: number } | null } };

export type GetUserEmailMutationVariables = Exact<{
  input: GetUserEmailInput;
}>;


export type GetUserEmailMutation = { __typename?: 'Mutation', getUserEmail: { __typename?: 'GetUserEmailOutput', ok: boolean, err?: string | null, users?: Array<{ __typename?: 'User', id: number, username?: string | null }> | null } };

export type ListAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAddressQuery = { __typename?: 'Query', listAddress: { __typename?: 'ListAddressOutput', ok: boolean, err?: string | null, address?: Array<{ __typename?: 'Address', id: number, username?: string | null, name?: string | null, phone?: string | null, zoneCode?: string | null, mainAddress?: string | null, subAddress?: string | null, message?: string | null, pass?: string | null, region?: string | null, isRep: boolean }> | null } };

export type ListBasketItemQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBasketItemQuery = { __typename?: 'Query', listBasketItem: { __typename?: 'ListBasketItemOutput', ok: boolean, err?: string | null, basketItems?: Array<{ __typename?: 'BasketItem', id: number, quantity: number, user: { __typename?: 'User', id: number }, good: { __typename?: 'Good', id: number, title: string, price?: number | null, limitNumOrders: number, discountRate?: number | null, status: GoodStatus, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, corporation?: { __typename?: 'Corporation', id: number, name: string, regionKeyWord?: Array<string> | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null } | null }, goodOption?: { __typename?: 'GoodOption', name?: string | null, id: number, deliveryDate?: any | null, isActive: boolean, dateActive: boolean, price?: number | null, discountRate?: number | null } | null }> | null } };

export type ListBasketItemServiceQueryVariables = Exact<{
  input: ListBasketItemServiceInput;
}>;


export type ListBasketItemServiceQuery = { __typename?: 'Query', listBasketItemService: { __typename?: 'ListBasketItemServiceOutput', ok: boolean, err?: string | null, basketItems?: Array<{ __typename?: 'BasketItem', id: number, quantity: number, user: { __typename?: 'User', id: number }, good: { __typename?: 'Good', id: number, title: string, price?: number | null, limitNumOrders: number, discountRate?: number | null, status: GoodStatus, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, corporation?: { __typename?: 'Corporation', name: string, regionKeyWord?: Array<string> | null, linkService?: { __typename?: 'LinkService', id: number, name: string, minAmount?: number | null } | null } | null }, goodOption?: { __typename?: 'GoodOption', name?: string | null, id: number, count?: number | null, deliveryDate?: any | null, isActive: boolean, dateActive: boolean, price?: number | null, discountRate?: number | null } | null }> | null } };

export type ListCorporationByLocationQueryVariables = Exact<{
  input: ListCorporationByLocationInput;
}>;


export type ListCorporationByLocationQuery = { __typename?: 'Query', listCorporationByLocation: { __typename?: 'ListCorporationByLocationOutput', ok: boolean, err?: string | null, mainCategories?: Array<{ __typename?: 'MainCategory', id: number, name: string, imageUrl?: string | null, upload?: { __typename?: 'Upload', url?: string | null, uuid?: string | null } | null }> | null, corporations?: Array<{ __typename?: 'Corporation', id: number, name: string, address?: string | null, isActive: boolean, coupons?: Array<{ __typename?: 'Coupon', id: number, name: string, status: CouponStatus, discountPrice?: number | null, validFrom: any, validUntil: any, userCoupons?: Array<{ __typename?: 'UserCoupon', id: number, status: UserCouponStatus }> | null }> | null, mainCategories?: Array<{ __typename?: 'MainCategory', id: number, name: string, imageUrl?: string | null, upload?: { __typename?: 'Upload', url?: string | null, uuid?: string | null } | null }> | null, goods?: Array<{ __typename?: 'Good', id: number, title: string, summary?: string | null, price?: number | null, discountRate?: number | null, status: GoodStatus, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodReviews?: Array<{ __typename?: 'GoodReview', id: number, note: string, rating: number }> | null }> | null }> | null } };

export type ListCorporationSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCorporationSelectQuery = { __typename?: 'Query', listCorporationSelect: { __typename?: 'ListCorporationSelectOutput', ok: boolean, err?: string | null, corporations?: Array<{ __typename?: 'Corporation', id: number, name: string, regionKeyWord?: Array<string> | null }> | null } };

export type ListCouponLocationQueryVariables = Exact<{
  input: ListCouponLocationInput;
}>;


export type ListCouponLocationQuery = { __typename?: 'Query', listCouponLocation: { __typename?: 'ListCouponLocationOutput', ok: boolean, err?: string | null, coupons?: Array<{ __typename?: 'CouponWithAvailability', isAvailable: boolean, userCouponId?: number | null, userCouponStatus?: UserCouponStatus | null, unavailableReason?: string | null, coupon: { __typename?: 'Coupon', id: number, name: string, scope: CouponScope, status: CouponStatus, validFrom: any, validUntil: any, discountPrice?: number | null, description?: string | null, code?: string | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null } }> | null } };

export type ListGoodQueryVariables = Exact<{
  input: ListGoodInput;
}>;


export type ListGoodQuery = { __typename?: 'Query', listGood: { __typename?: 'ListGoodOutput', ok: boolean, err?: string | null, goods?: Array<{ __typename?: 'Good', id: number, price?: number | null, status: GoodStatus, discountRate?: number | null, title: string, summary?: string | null, tags?: Array<Tags> | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodReviews?: Array<{ __typename?: 'GoodReview', id: number }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, createdAt?: any | null, name?: string | null, count?: number | null, price?: number | null, isActive: boolean, discountRate?: number | null, desc?: string | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null }> | null }> | null } };

export type ListGoodOptionQueryVariables = Exact<{
  input: ListGoodOptionInput;
}>;


export type ListGoodOptionQuery = { __typename?: 'Query', listGoodOption: { __typename?: 'ListGoodOptionOutput', ok: boolean, err?: string | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, createdAt?: any | null, name?: string | null, price?: number | null, isActive: boolean, discountRate?: number | null, deliveryDate?: any | null, desc?: string | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, good?: { __typename?: 'Good', id: number, price?: number | null, status: GoodStatus, discountRate?: number | null, title: string, summary?: string | null, subCategory?: { __typename?: 'SubCategory', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } | null }> | null } };

export type ListGoodRelationQueryVariables = Exact<{
  input: ListGoodRelationInput;
}>;


export type ListGoodRelationQuery = { __typename?: 'Query', listGoodRelation: { __typename?: 'ListGoodRelationOutput', ok: boolean, err?: string | null, goodRelations?: Array<{ __typename?: 'GoodRelation', index?: number | null, relatedGoods?: Array<{ __typename?: 'Good', id: number, title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }> | null }> | null } };

export type ListGoodReviewQueryVariables = Exact<{
  input: ListGoodReviewInput;
}>;


export type ListGoodReviewQuery = { __typename?: 'Query', listGoodReview: { __typename?: 'ListGoodReviewOutput', ok: boolean, err?: string | null, totalResults?: number | null, goodReviews?: Array<{ __typename?: 'GoodReview', id: number, createdAt?: any | null, note: string, rating: number, order?: { __typename?: 'Order', price?: number | null, amount: number } | null, author?: { __typename?: 'User', id: number, name?: string | null, username?: string | null } | null, good: { __typename?: 'Good', id: number, title: string }, goodReviewPosters?: Array<{ __typename?: 'GoodReviewPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }> | null } };

export type ListGoodSuggestionQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGoodSuggestionQuery = { __typename?: 'Query', listGoodSuggestion: { __typename?: 'ListGoodSuggestionOutput', ok: boolean, err?: string | null, goods?: Array<{ __typename?: 'Good', id: number, price?: number | null, status: GoodStatus, discountRate?: number | null, title: string, summary?: string | null, subCategory?: { __typename?: 'SubCategory', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, createdAt?: any | null, name?: string | null, price?: number | null, isActive: boolean, discountRate?: number | null, desc?: string | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null }> | null }> | null } };

export type ListInquiryQueryVariables = Exact<{
  input: ListInquiryInput;
}>;


export type ListInquiryQuery = { __typename?: 'Query', listInquiry: { __typename?: 'ListInquiryOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, inquiries?: Array<{ __typename?: 'Inquiry', id: number, title: string, note: string, status: InquiryStatus, type: InquiryType, createdAt?: any | null, author: { __typename?: 'User', id: number, name?: string | null, username?: string | null }, comments?: Array<{ __typename?: 'Comment', note: string }> | null, inquiryPosters?: Array<{ __typename?: 'InquiryPoster', id: number, upload?: { __typename?: 'Upload', id: number, url?: string | null } | null }> | null }> | null } };

export type ListInquiryCompleteQueryVariables = Exact<{
  input: ListInquiryCompleteInput;
}>;


export type ListInquiryCompleteQuery = { __typename?: 'Query', listInquiryComplete: { __typename?: 'ListInquiryCompleteOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, inquiries?: Array<{ __typename?: 'Inquiry', id: number, title: string, note: string, status: InquiryStatus, type: InquiryType, createdAt?: any | null, author: { __typename?: 'User', id: number, name?: string | null, username?: string | null }, comments?: Array<{ __typename?: 'Comment', note: string }> | null, inquiryPosters?: Array<{ __typename?: 'InquiryPoster', id: number, upload?: { __typename?: 'Upload', id: number, url?: string | null } | null }> | null }> | null } };

export type ListLinkServiceNearQueryVariables = Exact<{
  input: ListLinkServiceNearInput;
}>;


export type ListLinkServiceNearQuery = { __typename?: 'Query', listLinkServiceNear: { __typename?: 'ListLinkServiceNearOutput', ok: boolean, err?: string | null, linkservice?: Array<{ __typename?: 'LinkService', id: number, name: string, description?: string | null, latitude?: number | null, longitude?: number | null, address?: string | null, distance?: number | null, isActive: boolean }> | null } };

export type ListLinkServiceSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLinkServiceSelectQuery = { __typename?: 'Query', listLinkServiceSelect: { __typename?: 'ListLinkServiceSelectOutput', ok: boolean, err?: string | null, linkservice?: Array<{ __typename?: 'LinkService', id: number, name: string, link?: string | null }> | null } };

export type ListMyGoodReviewQueryVariables = Exact<{
  input: ListMyGoodReviewInput;
}>;


export type ListMyGoodReviewQuery = { __typename?: 'Query', listMyGoodReview: { __typename?: 'ListMyGoodReviewOutput', ok: boolean, err?: string | null, totalPages?: number | null, goodReviews?: Array<{ __typename?: 'GoodReview', id: number, createdAt?: any | null, note: string, rating: number, order?: { __typename?: 'Order', price?: number | null, amount: number } | null, author?: { __typename?: 'User', id: number, name?: string | null, username?: string | null } | null, good: { __typename?: 'Good', id: number, title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null, goodOptions?: Array<{ __typename?: 'GoodOption', name?: string | null, price?: number | null }> | null }, goodReviewPosters?: Array<{ __typename?: 'GoodReviewPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }> | null } };

export type ListOrderReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrderReviewQuery = { __typename?: 'Query', listOrderReview: { __typename?: 'ListOrderReviewOutput', ok: boolean, err?: string | null, orders?: Array<{ __typename?: 'Order', id: number, goodName: string, goodOptionName?: string | null, quantity: number, amount: number, status: OrderStatus, exchangeStatus: ExchangeStatus, redelivery?: Redelivery | null, review?: { __typename?: 'GoodReview', id: number } | null, goodOption?: { __typename?: 'GoodOption', id: number, name?: string | null, good?: { __typename?: 'Good', title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } | null } | null }> | null } };

export type ListPortByLocationQueryVariables = Exact<{
  input: ListPortByLocationInput;
}>;


export type ListPortByLocationQuery = { __typename?: 'Query', listPortByLocation: { __typename?: 'ListPortByLocationOutput', ok: boolean, err?: string | null, ports?: Array<{ __typename?: 'Port', id: number, name: string, address?: string | null, usageTime?: string | null, phone?: string | null, regionKeyWord?: Array<string> | null, latitude?: number | null, longitude?: number | null, author?: { __typename?: 'User', id: number, name?: string | null, phone?: string | null } | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null }> | null } };

export type ListPortPickupQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPortPickupQuery = { __typename?: 'Query', listPortPickup: { __typename?: 'ListPortPickUpOutput', ok: boolean, err?: string | null, ports?: Array<{ __typename?: 'Port', id: number, name: string, address?: string | null, usageTime?: string | null, phone?: string | null, regionKeyWord?: Array<string> | null, author?: { __typename?: 'User', id: number, name?: string | null, phone?: string | null } | null }> | null } };

export type ListReceiptQueryVariables = Exact<{
  input: ListReceiptInput;
}>;


export type ListReceiptQuery = { __typename?: 'Query', listReceipt: { __typename?: 'ListReceiptOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, receipts?: Array<{ __typename?: 'Receipt', id: number, uuid?: string | null, status?: string | null, paid_at?: string | null, paid_amount?: number | null, deliveryFee?: number | null, receiptStatus: ReceiptStatus, howToReceive?: HowToReceive | null, receiptNum?: string | null, orders?: Array<{ __typename?: 'Order', id: number, goodName: string, goodOptionName?: string | null, quantity: number, amount: number, status: OrderStatus, exchangeStatus: ExchangeStatus, redelivery?: Redelivery | null, review?: { __typename?: 'GoodReview', id: number } | null, orderReceipt?: { __typename?: 'OrderReceipt', id: number, order_quantity: number, good_discountRate?: number | null, order_price?: number | null, goodOption_name?: string | null, good_title?: string | null, good_poster_url?: string | null } | null, manager?: { __typename?: 'User', id: number, name?: string | null } | null, good?: { __typename?: 'Good', id: number, title: string, status: GoodStatus, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } | null, goodOption?: { __typename?: 'GoodOption', name?: string | null, id: number } | null }> | null }> | null } };

export type ListReceiptReviewQueryVariables = Exact<{
  input: ListReceiptReviewInput;
}>;


export type ListReceiptReviewQuery = { __typename?: 'Query', listReceiptReview: { __typename?: 'ListReceiptReviewOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, receipts?: Array<{ __typename?: 'Receipt', id: number, uuid?: string | null, status?: string | null, paid_at?: string | null, receiptStatus: ReceiptStatus, receiptNum?: string | null, orders?: Array<{ __typename?: 'Order', id: number, goodName: string, goodOptionName?: string | null, quantity: number, amount: number, status: OrderStatus, exchangeStatus: ExchangeStatus, redelivery?: Redelivery | null, orderReceipt?: { __typename?: 'OrderReceipt', good_discountRate?: number | null, good_title?: string | null, goodOption_name?: string | null, good_poster_url?: string | null } | null, review?: { __typename?: 'GoodReview', id: number } | null, good?: { __typename?: 'Good', id: number, title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } | null, goodOption?: { __typename?: 'GoodOption', id: number, name?: string | null } | null }> | null }> | null } };

export type ListRelatedGoodsQueryVariables = Exact<{
  input: ListRelatedGoodInput;
}>;


export type ListRelatedGoodsQuery = { __typename?: 'Query', listRelatedGoods: { __typename?: 'ListRelatedGoodOutput', ok: boolean, err?: string | null, relatedGoods?: Array<{ __typename?: 'Good', id: number, title: string, goodPosters?: Array<{ __typename?: 'GoodPoster', upload?: { __typename?: 'Upload', url?: string | null } | null }> | null }> | null } };

export type ListUserCouponQueryVariables = Exact<{
  input: ListUserCouponInput;
}>;


export type ListUserCouponQuery = { __typename?: 'Query', listUserCoupon: { __typename?: 'ListUserCouponOutput', ok: boolean, err?: string | null, coupons?: Array<{ __typename?: 'CouponWithAvailability', isAvailable: boolean, userCouponId?: number | null, userCouponStatus?: UserCouponStatus | null, unavailableReason?: string | null, coupon: { __typename?: 'Coupon', id: number, name: string, scope: CouponScope, status: CouponStatus, validFrom: any, validUntil: any, discountPrice?: number | null, description?: string | null, code?: string | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null } }> | null } };

export type LoginMutationVariables = Exact<{
  loginInput: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginOutput', ok: boolean, token?: string | null, id?: number | null, err?: string | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, username?: string | null, name?: string | null, phone?: string | null, role: UserRole, type?: UserType | null, isRead?: boolean | null, addresses?: Array<{ __typename?: 'Address', isRep: boolean, region?: string | null }> | null } };

export type PayReceiptMutationVariables = Exact<{
  input: PayReceiptInput;
}>;


export type PayReceiptMutation = { __typename?: 'Mutation', payReceipt: { __typename?: 'PayReceiptOutput', ok: boolean, err?: string | null, receipt?: { __typename?: 'Receipt', id: number, uuid?: string | null } | null } };

export type SendChangePasswordEmailMutationVariables = Exact<{
  input: SendChangePasswordEmailInput;
}>;


export type SendChangePasswordEmailMutation = { __typename?: 'Mutation', sendChangePasswordEmail: { __typename?: 'SendChangePasswordEmailOutput', ok: boolean, err?: string | null } };

export type SetIsReadMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type SetIsReadMutation = { __typename?: 'Mutation', setIsRead: { __typename?: 'CoreOutput', ok: boolean, err?: string | null } };

export type SnsLoginMutationVariables = Exact<{
  input: SnsLoginInput;
}>;


export type SnsLoginMutation = { __typename?: 'Mutation', snsLogin: { __typename?: 'SnsLoginOutput', ok: boolean, token?: string | null, exist?: boolean | null, id?: number | null, err?: string | null, username?: string | null } };

export type UpAddressMutationVariables = Exact<{
  input: UpAddressInput;
}>;


export type UpAddressMutation = { __typename?: 'Mutation', upAddress: { __typename?: 'UpAddressOutput', ok: boolean, err?: string | null } };

export type UpBasketItemMutationVariables = Exact<{
  input: UpBasketItemInput;
}>;


export type UpBasketItemMutation = { __typename?: 'Mutation', upBasketItem: { __typename?: 'UpBasketItemOutput', ok: boolean, err?: string | null } };

export type EditGoodReviewMutationVariables = Exact<{
  input: EditGoodReviewInput;
}>;


export type EditGoodReviewMutation = { __typename?: 'Mutation', editGoodReview: { __typename?: 'EditgoodReviewOutput', ok: boolean, err?: string | null } };

export type EditInquiryMutationVariables = Exact<{
  input: EditInquiryInput;
}>;


export type EditInquiryMutation = { __typename?: 'Mutation', editInquiry: { __typename?: 'EditInquiryOutput', ok: boolean, err?: string | null } };

export type EditOrderStatusMutationVariables = Exact<{
  input: EditOrderStatusInput;
}>;


export type EditOrderStatusMutation = { __typename?: 'Mutation', editOrderStatus: { __typename?: 'EditOrderStatusOutput', ok: boolean, err?: string | null } };

export type UpReceiptAddressMutationVariables = Exact<{
  input: UpReceiptAddressInput;
}>;


export type UpReceiptAddressMutation = { __typename?: 'Mutation', upReceiptAddress: { __typename?: 'UpReceiptAddressOutput', ok: boolean, err?: string | null } };

export type CancelReceiptMutationVariables = Exact<{
  input: UpReceiptCancelInput;
}>;


export type CancelReceiptMutation = { __typename?: 'Mutation', cancelReceipt: { __typename?: 'UpReceiptCancelOutput', ok: boolean, err?: string | null } };

export type UpUserMutationVariables = Exact<{
  input: UpUserInput;
}>;


export type UpUserMutation = { __typename?: 'Mutation', upUser: { __typename?: 'UpUserOutput', ok: boolean, err?: string | null } };

export type UpUserPasswordMutationVariables = Exact<{
  input: UpUserPasswordInput;
}>;


export type UpUserPasswordMutation = { __typename?: 'Mutation', upUserPassword: { __typename?: 'UpUserPasswordOutput', ok: boolean, err?: string | null } };


export const ChkAddressAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"chkAddressArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChkAddressAreaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chkAddressArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryArea"}}]}}]}}]} as unknown as DocumentNode<ChkAddressAreaQuery, ChkAddressAreaQueryVariables>;
export const CrAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}}]}}]} as unknown as DocumentNode<CrAddressMutation, CrAddressMutationVariables>;
export const CrBasketItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crBasketItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrBasketItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crBasketItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrBasketItemMutation, CrBasketItemMutationVariables>;
export const CrGoodReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGoodReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGoodReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrGoodReviewMutation, CrGoodReviewMutationVariables>;
export const CrGoodReviewPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGoodReviewPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodReviewPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGoodReviewPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodReviewPoster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CrGoodReviewPosterMutation, CrGoodReviewPosterMutationVariables>;
export const CrInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrInquiryMutation, CrInquiryMutationVariables>;
export const CrInquiryPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crInquiryPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrInquiryPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crInquiryPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryPoster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CrInquiryPosterMutation, CrInquiryPosterMutationVariables>;
export const CrReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrReceiptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]} as unknown as DocumentNode<CrReceiptMutation, CrReceiptMutationVariables>;
export const CrSnsUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crSnsUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrSnsUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crSnsUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CrSnsUserMutation, CrSnsUserMutationVariables>;
export const CrUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrUserMutation, CrUserMutationVariables>;
export const CrUserCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crUserCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrUserCouponInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crUserCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrUserCouponMutation, CrUserCouponMutationVariables>;
export const DelAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelAddressMutation, DelAddressMutationVariables>;
export const DelBasketItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delBasketItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelBasketItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delBasketItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelBasketItemMutation, DelBasketItemMutationVariables>;
export const DelGoodReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delGoodReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelGoodReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delGoodReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelGoodReviewMutation, DelGoodReviewMutationVariables>;
export const DelGoodReviewPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delGoodReviewPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelGoodReviewPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delGoodReviewPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelGoodReviewPosterMutation, DelGoodReviewPosterMutationVariables>;
export const DelInquiryPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delInquiryPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelInquiryPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delInquiryPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelInquiryPosterMutation, DelInquiryPosterMutationVariables>;
export const DelUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelUserMutation, DelUserMutationVariables>;
export const GetAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"zoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"mainAddress"}},{"kind":"Field","name":{"kind":"Name","value":"subAddress"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"pass"}},{"kind":"Field","name":{"kind":"Name","value":"isRep"}}]}}]}}]}}]} as unknown as DocumentNode<GetAddressMutation, GetAddressMutationVariables>;
export const GetBannerMainActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBannerMainActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetBannerMainActiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBannerMainActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"bannerMain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"mainType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"isFree"}},{"kind":"Field","name":{"kind":"Name","value":"isRes"}},{"kind":"Field","name":{"kind":"Name","value":"isEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isOnePlusOne"}},{"kind":"Field","name":{"kind":"Name","value":"linkServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBannerMainActiveQuery, GetBannerMainActiveQueryVariables>;
export const GetBannerMainEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBannerMainEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetBannerMainEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBannerMainEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"bannerMainEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBannerMainEventQuery, GetBannerMainEventQueryVariables>;
export const GetBannerOptionActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBannerOptionActive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBannerOptionActive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"bannerOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"isFree"}},{"kind":"Field","name":{"kind":"Name","value":"isRes"}},{"kind":"Field","name":{"kind":"Name","value":"isEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isOnePlusOne"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBannerOptionActiveQuery, GetBannerOptionActiveQueryVariables>;
export const GetCorporationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCorporationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"operationFrom"}},{"kind":"Field","name":{"kind":"Name","value":"operationTo"}},{"kind":"Field","name":{"kind":"Name","value":"holiday"}},{"kind":"Field","name":{"kind":"Name","value":"ceoName"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddress"}},{"kind":"Field","name":{"kind":"Name","value":"mainCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"userCoupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCorporationQuery, GetCorporationQueryVariables>;
export const GetCorporationCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporationCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCorporationCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporationCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"subCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCorporationCategoryQuery, GetCorporationCategoryQueryVariables>;
export const GetGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"attributeSet"}},{"kind":"Field","name":{"kind":"Name","value":"goodAttrInfo"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"limitNumOrders"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"goodReviewPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"detailType"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"relatedGoods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGoodQuery, GetGoodQueryVariables>;
export const GetGoodReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGoodReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetGoodReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGoodReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderReceipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"good_poster_url"}},{"kind":"Field","name":{"kind":"Name","value":"good_title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviewPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGoodReviewQuery, GetGoodReviewQueryVariables>;
export const GetInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiryPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInquiryQuery, GetInquiryQueryVariables>;
export const GetJoinUserCertDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getJoinUserCertData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetJoinUserCertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJoinUserCertData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<GetJoinUserCertDataMutation, GetJoinUserCertDataMutationVariables>;
export const GetKakaoEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getKakaoEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetKakaoEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKakaoEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetKakaoEmailQuery, GetKakaoEmailQueryVariables>;
export const GetLinkServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetLinkServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLinkService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkServiceQuery, GetLinkServiceQueryVariables>;
export const GetLinkServiceNearDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkServiceNear"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetLinkServiceNearInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLinkServiceNear"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"linkservice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkServiceNearQuery, GetLinkServiceNearQueryVariables>;
export const GetOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"orderReceipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"good_discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"order_price"}},{"kind":"Field","name":{"kind":"Name","value":"goodOption_name"}},{"kind":"Field","name":{"kind":"Name","value":"good_title"}},{"kind":"Field","name":{"kind":"Name","value":"good_poster_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"howToReceive"}},{"kind":"Field","name":{"kind":"Name","value":"port"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"usageTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exchangeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"redelivery"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const GetPaymentDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getPaymentData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPaymentDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPaymentData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basketItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRep"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRep"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPaymentDataMutation, GetPaymentDataMutationVariables>;
export const GetPgOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPgOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPgOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPgOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"pgOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"receipt_url"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPgOptionQuery, GetPgOptionQueryVariables>;
export const GetReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetReceiptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFee"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"howToReceive"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"pass"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"receiver"}},{"kind":"Field","name":{"kind":"Name","value":"port"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"usageTime"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"basketItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRep"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRep"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReceiptQuery, GetReceiptQueryVariables>;
export const GetUpUserCertDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getUpUserCertData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetUpUserCertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUpUserCertData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUpUserCertDataMutation, GetUpUserCertDataMutationVariables>;
export const GetUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetUserEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserEmailMutation, GetUserEmailMutationVariables>;
export const ListAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"zoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"mainAddress"}},{"kind":"Field","name":{"kind":"Name","value":"subAddress"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"pass"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"isRep"}}]}}]}}]}}]} as unknown as DocumentNode<ListAddressQuery, ListAddressQueryVariables>;
export const ListBasketItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listBasketItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBasketItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"basketItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"limitNumOrders"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"dateActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListBasketItemQuery, ListBasketItemQueryVariables>;
export const ListBasketItemServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listBasketItemService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListBasketItemServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBasketItemService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"basketItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"limitNumOrders"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"dateActive"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListBasketItemServiceQuery, ListBasketItemServiceQueryVariables>;
export const ListCorporationByLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCorporationByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCorporationByLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCorporationByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"mainCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"userCoupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCorporationByLocationQuery, ListCorporationByLocationQueryVariables>;
export const ListCorporationSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCorporationSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCorporationSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"corporations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}}]}}]}}]}}]} as unknown as DocumentNode<ListCorporationSelectQuery, ListCorporationSelectQueryVariables>;
export const ListCouponLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCouponLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCouponLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCouponLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"userCouponId"}},{"kind":"Field","name":{"kind":"Name","value":"userCouponStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableReason"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCouponLocationQuery, ListCouponLocationQueryVariables>;
export const ListGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodQuery, ListGoodQueryVariables>;
export const ListGoodOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodOptionQuery, ListGoodOptionQueryVariables>;
export const ListGoodRelationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodRelation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodRelation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"relatedGoods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodRelationQuery, ListGoodRelationQueryVariables>;
export const ListGoodReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"goodReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviewPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodReviewQuery, ListGoodReviewQueryVariables>;
export const ListGoodSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodSuggestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodSuggestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodSuggestionQuery, ListGoodSuggestionQueryVariables>;
export const ListInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiryPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListInquiryQuery, ListInquiryQueryVariables>;
export const ListInquiryCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listInquiryComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListInquiryCompleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listInquiryComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiryPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListInquiryCompleteQuery, ListInquiryCompleteQueryVariables>;
export const ListLinkServiceNearDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLinkServiceNear"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLinkServiceNearInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLinkServiceNear"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"linkservice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<ListLinkServiceNearQuery, ListLinkServiceNearQueryVariables>;
export const ListLinkServiceSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLinkServiceSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLinkServiceSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"linkservice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]} as unknown as DocumentNode<ListLinkServiceSelectQuery, ListLinkServiceSelectQueryVariables>;
export const ListMyGoodReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listMyGoodReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListMyGoodReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMyGoodReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"goodReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReviewPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListMyGoodReviewQuery, ListMyGoodReviewQueryVariables>;
export const ListOrderReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listOrderReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOrderReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"redelivery"}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListOrderReviewQuery, ListOrderReviewQueryVariables>;
export const ListPortByLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPortByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPortByLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPortByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"ports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"usageTime"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<ListPortByLocationQuery, ListPortByLocationQueryVariables>;
export const ListPortPickupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPortPickup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPortPickup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"ports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"usageTime"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}}]}}]}}]}}]} as unknown as DocumentNode<ListPortPickupQuery, ListPortPickupQueryVariables>;
export const ListReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListReceiptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"receipts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"receiptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"howToReceive"}},{"kind":"Field","name":{"kind":"Name","value":"receiptNum"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"orderReceipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"good_discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"order_price"}},{"kind":"Field","name":{"kind":"Name","value":"goodOption_name"}},{"kind":"Field","name":{"kind":"Name","value":"good_title"}},{"kind":"Field","name":{"kind":"Name","value":"good_poster_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"redelivery"}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListReceiptQuery, ListReceiptQueryVariables>;
export const ListReceiptReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listReceiptReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListReceiptReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listReceiptReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"receipts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"receiptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"receiptNum"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderReceipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"good_discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"good_title"}},{"kind":"Field","name":{"kind":"Name","value":"goodOption_name"}},{"kind":"Field","name":{"kind":"Name","value":"good_poster_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"redelivery"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListReceiptReviewQuery, ListReceiptReviewQueryVariables>;
export const ListRelatedGoodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listRelatedGoods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListRelatedGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listRelatedGoods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"relatedGoods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListRelatedGoodsQuery, ListRelatedGoodsQueryVariables>;
export const ListUserCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listUserCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListUserCouponInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listUserCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"userCouponId"}},{"kind":"Field","name":{"kind":"Name","value":"userCouponStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableReason"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListUserCouponQuery, ListUserCouponQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRep"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const PayReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"payReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PayReceiptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]} as unknown as DocumentNode<PayReceiptMutation, PayReceiptMutationVariables>;
export const SendChangePasswordEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendChangePasswordEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendChangePasswordEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendChangePasswordEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<SendChangePasswordEmailMutation, SendChangePasswordEmailMutationVariables>;
export const SetIsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetIsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setIsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<SetIsReadMutation, SetIsReadMutationVariables>;
export const SnsLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"snsLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SnsLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"snsLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"exist"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<SnsLoginMutation, SnsLoginMutationVariables>;
export const UpAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<UpAddressMutation, UpAddressMutationVariables>;
export const UpBasketItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upBasketItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpBasketItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upBasketItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<UpBasketItemMutation, UpBasketItemMutationVariables>;
export const EditGoodReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodReviewMutation, EditGoodReviewMutationVariables>;
export const EditInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditInquiryMutation, EditInquiryMutationVariables>;
export const EditOrderStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrderStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrderStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrderStatusMutation, EditOrderStatusMutationVariables>;
export const UpReceiptAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upReceiptAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpReceiptAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upReceiptAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<UpReceiptAddressMutation, UpReceiptAddressMutationVariables>;
export const CancelReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpReceiptCancelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CancelReceiptMutation, CancelReceiptMutationVariables>;
export const UpUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<UpUserMutation, UpUserMutationVariables>;
export const UpUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upUserPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpUserPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upUserPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<UpUserPasswordMutation, UpUserPasswordMutationVariables>;